import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { windowTime } from 'rxjs/operator/windowTime';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { IrFieldsService } from '../../shared/services/ir-fields.service';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { CompanySetupService } from '../../shared/services/company-setup.service';
import { EesDesService } from '../../shared/services/ees-des.service';
import * as jsPDF from 'jspdf';
import * as _html2canvas from "html2canvas";
@Component({
  selector: 'app-generic-modal-popup',
  templateUrl: './generic-modal-popup.component.html',
  styleUrls: ['./generic-modal-popup.component.scss'],
  providers:[CompanySetupService,WebServiceService,IrFieldsService]

})
export class GenericModalPopupComponent implements OnInit {
  @Input() modalDetails: any;
  @Output()
  sendAction = new EventEmitter()
  commonVariableList: any = {
    "actionsList": [{
      "name": "View",
      "icon": "fa fa-eye",
      "action": "view"
    }],
    "dataList": [],
    "columnList": [],
    "afterdivList": [],
    "beforedivList": [],
    "isProgressing": true,
    "modalDetails": {},
    "dataDetails": {},
    "tableDetails": {is_setup:false,setup:{}},
    "attachments": [],
    "approvalDetails": {is_setup:false,setup:{}},
    "afterDivDetails": {is_setup:false,setup:{}},
    "beforeDivDetails": {is_setup:false,setup:{}},
    "allocableCostDetails": {is_setup:false,setup:{},is_view:false},
    "is_history":false,
    "historyList":[],
    "additional_attachment": {'title':'','attachment':[]},
    "contractualPoAttachments": {'title':'Attach Signed Contract Copy','attachment':[]},
    "fulfilled_po_upload_invoice": [],
    "fulfilled_po_upload_invoice_title": '',
    "fulfilled_po_vendor_attachment": [],
    "fulfilled_po_vendor_attachment_title": '',
    "is_allocable_cost": false,
    "allocableCostLines": [],
    "document_currency_code": '',
  };
  is_recurring:boolean=false
  page_url:any=window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  irn_to_grn: any;
  grn_to_qc: any;
  constructor(public eesdesService:EesDesService,public webService: WebServiceService,
    public irFields: IrFieldsService,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    private router: Router, private titleService: Title,public comanySetup:CompanySetupService ) {
    this.initListener();

  }
  company_setup: any = {};
  country_data:any={}
  setup:any={}
modal_setup:any={}
companyThemeBlockColor: any = "";
CompanyThemetextColor: any = "";

  // Product master (view-only) support for PR module hyperlink
  visibleProductMaster: any = { isCreateVisible: false, isViewVisible: true, isProgressing: false };
  isViewModeProductMaster: boolean = true;

  // Variables to match master Product UI template
  visible: any = this.visibleProductMaster;
  isViewMode: boolean = true;
  productData: any[] = [];
  companySelectionDisabled: boolean = true;
  isEmpCodeDisable: boolean = true;
  showErpVar: boolean = true;
  isApproverEdit: boolean = false;

  // Vendor master (view-only) popup for Invoice Approval hyperlink
  vendorMasterData: any = {};
  vendorMasterColumnList: any[] = [];
  vendorMasterAttachments: any[] = [];
  vendorMasterPanFiles: any[] = [];
  vendorMasterGstFiles: any[] = [];
  vendorMasterMsmeFiles: any[] = [];
  vendorMasterEInvoiceFiles: any[] = [];
  vendorMasterSectionFiles: any[] = [];
  vendorMasterAgreementAttachments: any[] = [];
  vendorMasterAdditionalDocuments: any[] = [];
  vendorMasterAdditionalDocumentRows: any[] = [];
  vendorMasterLocationAttachments: any[] = [];
  vendorMasterShowExpiryInDocs: boolean = false;
  vendorMasterShowRemarksInDocs: boolean = false;
  vendorMasterActiveTab: number = 1;

  // Minimal dropdown lists (filled from response for view-only)
  UnitTypeList: any[] = [];
  hsncodelist: any[] = [];
  typeList: any[] = [];
  typeList2: any[] = [];
  productCategory: any[] = [];
  productSubCategory: any[] = [];
  accountCodeList: any[] = [];
  qcList: any[] = [];
  tdsList: any[] = [];
  approvalList: any[] = [];

  // Search models used by md2-select headers
  searcUnitType: string = '';
  searchHsn: string = '';
  searchProductType2: string = '';
  searcCategoryType: string = '';
  searcSubCategoryType: string = '';
  searchAccountType: string = '';
  searchconsumption_stock_account: string = '';
  searchnon_boq_production_stock_account: string = '';
  searchQC: string = '';
  searchTdsList: string = '';
  searchApproval: string = '';
  approval: any = '';
  savedFiles: any[] = [];
  isUploading: boolean = false;
  ngOnInit() {
    let t:any={};
    t = this.eesdesService.get('country_data',localStorage.getItem('country_data')) ? this.eesdesService.get('country_data',localStorage.getItem('country_data')) : {};
    console.log(t);
    if(t.country_id!==''&&t.country_id!==undefined&&t.country_id!==null)
    {
      this.country_data=t;
    }
    this.setup=this.modalDetails.setup?this.modalDetails.setup:{}
      this.setup.is_setup=this.modalDetails.is_setup?this.modalDetails.is_setup:false;

    if(this.setup.is_setup)
    {
            this.modal_setup=this.setup;
      this.comanySetup.setData(this.modal_setup);
      this.setSetupData(this.setup);
    }
    else
    {
          this.GetCompanySetUpData();
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
   this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
{
  return false;
}
    let req:any={}
    this.company_setup={}
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup.comma_separate_currency_code = this.company_setup.comma_separate_currency_code ? this.company_setup.comma_separate_currency_code : 'IND';
          this.company_setup.is_enable_comma_separate_price = this.company_setup.is_enable_comma_separate_price ? this.company_setup.is_enable_comma_separate_price : '0';
          this.company_setup.enable_parallel_approver_in_dc_note_module = this.company_setup.enable_parallel_approver_in_dc_note_module ? this.company_setup.enable_parallel_approver_in_dc_note_module : '0';
          this.company_setup.questionnaire_upload_table_in_irn = this.company_setup.questionnaire_upload_table_in_irn ? this.company_setup.questionnaire_upload_table_in_irn : [];
          this.company_setup.questionnaire_upload_table_in_gate_pass = this.company_setup.questionnaire_upload_table_in_gate_pass ? this.company_setup.questionnaire_upload_table_in_gate_pass : [];
          this.company_setup.gate_pass_additional_fields_configuration = this.company_setup.gate_pass_additional_fields_configuration ? this.company_setup.gate_pass_additional_fields_configuration : [];
          this.company_setup.gate_pass_vendor_email_notification = this.company_setup.gate_pass_vendor_email_notification ? this.company_setup.gate_pass_vendor_email_notification : [];
          this.company_setup.show_scan_invoice_attachment_in_gate_pass = this.company_setup.show_scan_invoice_attachment_in_gate_pass ? this.company_setup.show_scan_invoice_attachment_in_gate_pass : '0';
          this.company_setup.enable_questionnarie_files = this.company_setup.enable_questionnarie_files ? this.company_setup.enable_questionnarie_files : "0";
          this.company_setup.upload_file_for_custom_name = this.company_setup.upload_file_for_custom_name ? this.company_setup.upload_file_for_custom_name : 'Custom name Upload File';
          this.company_setup.its_note_visibale = this.company_setup.its_note_visibale ? this.company_setup.its_note_visibale : 'Note';
         
          this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink = this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink ? this.company_setup.enable_po_additional_attachment_display_in_po_hyperlink : "0";

          this.setSetupData(data.response);
      }
      }, error => {

      }
    )
  }
  setSetupData(data)
  {
          this.company_setup=data ? data : {}
          this.company_setup.display_gstin_with_cost_center_and_vendor = this.company_setup.display_gstin_with_cost_center_and_vendor ? this.company_setup.display_gstin_with_cost_center_and_vendor : '0';
          this.company_setup.gstin_display_label = this.company_setup.gstin_display_label ? this.company_setup.gstin_display_label : 'GST';
          this.company_setup.display_gst_number_in_bill_to_and_ship_to_locations = this.company_setup.display_gst_number_in_bill_to_and_ship_to_locations ? this.company_setup.display_gst_number_in_bill_to_and_ship_to_locations : '0';
          this.company_setup.allow_post_payment_debit_note_in_dc_note = this.company_setup.allow_post_payment_debit_note_in_dc_note ? this.company_setup.allow_post_payment_debit_note_in_dc_note : '0';
          this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
          if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
            this.company_setup.product_catalog_id = '1'
          }
          // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';
          this.company_setup.merge_grn_irn = this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0';
          this.company_setup.enable_free_quantity_in_po = this.company_setup.enable_free_quantity_in_po ? this.company_setup.enable_free_quantity_in_po : '0';
          this.company_setup.has_multi_grn_approval = this.company_setup.has_multi_grn_approval ? this.company_setup.has_multi_grn_approval : '0';
          this.company_setup.is_delivery_cc_visible = this.company_setup.is_delivery_cc_visible ? this.company_setup.is_delivery_cc_visible : '0';
          this.company_setup.is_delivery_cc_visible_po = this.company_setup.is_delivery_cc_visible_po ? this.company_setup.is_delivery_cc_visible_po : "0";
          this.company_setup.show_lob_dropdown = this.company_setup.show_lob_dropdown ? this.company_setup.show_lob_dropdown : '0';
          this.company_setup.show_loc_dropdown = this.company_setup.show_loc_dropdown ? this.company_setup.show_loc_dropdown : '0';
          this.company_setup.show_dept_dropdown = this.company_setup.show_dept_dropdown ? this.company_setup.show_dept_dropdown : '0';

          this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv = this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_bm_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv = this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_sppartner_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv = this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv ? this.company_setup.is_emp_no_dd_visible_in_allocate_costcenter_in_inv : '0';
          this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv = this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv ? this.company_setup.is_cc_disabled_in_allocate_costcenter_in_inv : '0';
          this.company_setup.hide_numaric_number_in_lob_loc_dep = this.company_setup.hide_numaric_number_in_lob_loc_dep ? this.company_setup.hide_numaric_number_in_lob_loc_dep : '0';
          this.company_setup.po_expiry_date_visible = this.company_setup.po_expiry_date_visible ? this.company_setup.po_expiry_date_visible : "0";
          this.company_setup.custom_name_for_po_expiry_date = this.company_setup.custom_name_for_po_expiry_date ? this.company_setup.custom_name_for_po_expiry_date : "0";
          this.company_setup.po_expiry_date_mandatory = this.company_setup.po_expiry_date_mandatory ? this.company_setup.po_expiry_date_mandatory : "0";
          this.company_setup.is_accepted_qty_hidden = false;
          this.company_setup.is_paid_price_hidden = false;
          this.company_setup.is_total_paid_price_hidden = false;
          this.company_setup.is_difference_price_hidden = false;
          this.company_setup.is_total_difference_price_hidden = false;
          this.company_setup.is_total_price_hidden = false;
          // this.company_setup.is_product_description_hidden = false;
          this.company_setup.is_product_type_hidden = false;
          this.company_setup.is_unit_type_hidden = false;
          this.company_setup.is_remarks_hidden = false;
          this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "";

          this.company_setup.is_paid_cgst_hidden = false;
          this.company_setup.is_paid_sgst_hidden = false;
          this.company_setup.is_paid_igst_hidden = false;
          this.company_setup.is_total_paid_price_gst_hidden = false;
          this.company_setup.direct_invoice_columnList = this.company_setup.direct_invoice_columnList ? this.company_setup.direct_invoice_columnList : []
          if (this.company_setup.direct_invoice_columnList.length > 0) {
            this.company_setup.is_accepted_qty_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup.is_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup.is_total_paid_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup.is_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup.is_total_difference_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup.is_total_price_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            // this.company_setup.is_product_description_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_description' && v.isVisible });
            this.company_setup.is_product_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup.is_unit_type_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup.is_remarks_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup.is_paid_cgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup.is_paid_sgst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup.is_paid_igst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup.is_total_paid_price_gst_hidden = this.company_setup.direct_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
          }

          this.company_setup.in_add_invoice_accepted_qty_hidden = false;
          this.company_setup.in_add_invoice_paid_price_hidden = false;
          this.company_setup.in_add_invoice_total_paid_price_hidden = false;
          this.company_setup.in_add_invoice_difference_price_hidden = false;
          this.company_setup.in_add_invoice_total_difference_price_hidden = false;
          this.company_setup.in_add_invoice_total_price_hidden = false;
          this.company_setup.in_add_invoice_product_type_hidden = false;
          this.company_setup.in_add_invoice_unit_type_hidden = false;
          this.company_setup.in_add_invoice_remarks_hidden = false;
          this.company_setup.in_add_invoice_paid_cgst_hidden = false;
          this.company_setup.in_add_invoice_paid_sgst_hidden = false;
          this.company_setup.in_add_invoice_paid_igst_hidden = false;
          this.company_setup.in_add_invoice_total_paid_price_gst_hidden = false;
          this.company_setup.in_add_invoice_rejected_qty_hidden = false;

          this.company_setup.add_invoice_columnList = this.company_setup.add_invoice_columnList ? this.company_setup.add_invoice_columnList : []
          if (this.company_setup.add_invoice_columnList.length > 0) {
            this.company_setup.in_add_invoice_accepted_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'accepted_qty' && v.isVisible });
            this.company_setup.in_add_invoice_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_paid_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price' && v.isVisible });
            this.company_setup.in_add_invoice_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'difference_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_difference_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_difference_price' && v.isVisible });
            this.company_setup.in_add_invoice_total_price_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_price' && v.isVisible });
            this.company_setup.in_add_invoice_product_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'product_type' && v.isVisible });
            this.company_setup.in_add_invoice_unit_type_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'unit_type' && v.isVisible });
            this.company_setup.in_add_invoice_remarks_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'remarks' && v.isVisible });
            this.company_setup.in_add_invoice_paid_cgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_cgst' && v.isVisible });
            this.company_setup.in_add_invoice_paid_sgst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_sgst' && v.isVisible });
            this.company_setup.in_add_invoice_paid_igst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'paid_igst' && v.isVisible });
            this.company_setup.in_add_invoice_total_paid_price_gst_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'total_paid_price_gst' && v.isVisible });
            this.company_setup.in_add_invoice_rejected_qty_hidden = this.company_setup.add_invoice_columnList.some((v) => { return v.id == 'rejected_qty' && v.isVisible });
          }

          this.company_setup.invoice_raiser_hide_tds = this.company_setup.invoice_raiser_hide_tds ? this.company_setup.invoice_raiser_hide_tds : '0';
          if(this.page_url != 'all-invoices' && this.page_url != 'draft-invoice') {
            this.company_setup.invoice_raiser_hide_tds = '0';
          }
          this.company_setup.pr_customer_custom_name = this.company_setup.pr_customer_custom_name ? this.company_setup.pr_customer_custom_name : 'Customer';
          this.company_setup.is_budget_selection_at_item_level_in_product_table = this.company_setup.is_budget_selection_at_item_level_in_product_table ? this.company_setup.is_budget_selection_at_item_level_in_product_table : '0';
          this.company_setup.rename_project = this.company_setup.rename_project ? this.company_setup.rename_project : 'Project';
          this.company_setup.rename_task = this.company_setup.rename_task ? this.company_setup.rename_task : 'Task';
          this.company_setup.is_different_document_currency = this.company_setup.is_different_document_currency ? this.company_setup.is_different_document_currency : 'Is DDC';
          this.company_setup.pdf_option_in_all_approved_inv=this.company_setup.pdf_option_in_all_approved_inv?this.company_setup.pdf_option_in_all_approved_inv:'0',
          this.company_setup.modified_irn_to_grn = this.company_setup.modified_irn_to_grn ? this.company_setup.modified_irn_to_grn : '0';
          this.irn_to_grn = (this.company_setup.modified_irn_to_grn == 1) ? "GRN" : "IRN";
          this.company_setup.modified_grn_to_qc = this.company_setup.modified_grn_to_qc ? this.company_setup.modified_grn_to_qc : '0';
          this.grn_to_qc = (this.company_setup.modified_grn_to_qc == 1) ? "QC" : "GRN";
          this.company_setup.attachments_visible_raise_po = this.company_setup.attachments_visible_raise_po ? this.company_setup.attachments_visible_raise_po : '0';
          this.company_setup.enable_ddc_in_pr = this.company_setup.enable_ddc_in_pr ? this.company_setup.enable_ddc_in_pr : '0';
          this.company_setup.show_voucher_type_in_inv = this.company_setup.show_voucher_type_in_inv ? this.company_setup.show_voucher_type_in_inv : "0";
          this.company_setup.is_show_vendor_at_pr_level = this.company_setup.is_show_vendor_at_pr_level ? this.company_setup.is_show_vendor_at_pr_level : '0';
          this.company_setup.is_vendor_editable_in_pr_approver = this.company_setup.is_vendor_editable_in_pr_approver ? this.company_setup.is_vendor_editable_in_pr_approver : '0';
          this.company_setup.vendor_invoice_column_list=this.company_setup.vendor_invoice_column_list?this.company_setup.vendor_invoice_column_list:[];
          this.company_setup.irn_number_editable = this.company_setup.irn_number_editable ? this.company_setup.irn_number_editable : '0';
          this.company_setup.enable_unplanned_checkbox_for_line_items = this.company_setup.enable_unplanned_checkbox_for_line_items ? this.company_setup.enable_unplanned_checkbox_for_line_items : '0';
          this.modal_setup = this.company_setup;
          this.comanySetup.setData(this.modal_setup);

          if (this.modalDetails.data) {
            this.apiCall();
          }
          document.getElementById('body').style.overflow = 'hidden';

  }
  apiCall() {
    this.commonVariableList.is_history=this.modalDetails.is_history?this.modalDetails.is_history:false;
    switch (this.modalDetails.id) {
      case 'productmaster':
        this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Product Master Details';
        this.showProductMaster(this.modalDetails.data);
        break;
      case 'vendormaster':
        this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Vendor Details';
        this.showVendorMaster(this.modalDetails.data);
        break;
      case 'invoicepaymentreport':
        this.showInvoicePayment(this.modalDetails.data);
        break;
        case 'adhocpaymentreport':
          this.showAdhocPayment(this.modalDetails.data);
          break;
        case 'invoice_android_report':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/generate-invoice-android');

        this.showAndroidInvoice(this.modalDetails.data);
        break;
        case 'recurring_invoicereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/create-curring-inv');
        this.is_recurring=this.page_url=='auto-generated-inv'
        this.showRecurringInvoice(this.modalDetails.data);
        break;
      case 'invoicereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-invoice-v2');

        this.showInvoice(this.modalDetails.data);
        break;
      case 'salesinvoicereport':
        this.showSalesInvoice(this.modalDetails.data);
        break;
      case 'grnreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-grn');

        this.showGrn(this.modalDetails.data);
        break;
      case 'gatepassreport':
        this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Gate Pass Data';
        this.showGatePass(this.modalDetails.data);
        break;
      case 'gatepass_history_report':
        this.modalDetails.name = "Gate Pass History";
        this.showGatePassHistory(this.modalDetails.data);
        break;
      case 'irnreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/new-irn');

        this.showIrn(this.modalDetails.data);
        break;
      case 'poreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raise-po');

        this.showPo(this.modalDetails.data);
        break;
        case 'dcnotereport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/my-debit-credit');
        this.showDCNote(this.modalDetails.data);
        break;
      case 'prreport':
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raisepr');

        this.showPr(this.modalDetails.data);
        break;
        case 'irreport':
            this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raiseir');

          this.showIr(this.modalDetails.data);
          break;
          case 'ir_history_report':
            this.modalDetails.name="IR History"

          this.showIRHistory(this.modalDetails.data);
          break;
      case 'my_advance_report':
        this.showMyAdvance(this.modalDetails.data);
        break;
      case 'employee_advance_payment_report':
        this.showEmployeeAdvancePayment(this.modalDetails.data);
        break;
      case 'rfqNumberReport':
        this.showRfqData(this.modalDetails.data, "rfqNumberReport");
        break;
      case 'rfqResponseReport':
        this.showRfqData(this.modalDetails.data, "rfqResponseReport");
        break;
      case 'creditnotereport':
        this.modalDetails.name = "Vendor Credit Note";
        this.showVendorCreditNote(this.modalDetails.data,);
        break;
      default:
        this.toasterService.pop('error', "Error", "Wrong Data");
    }
  }

  // Gate Pass History (PO-style UI inside generic modal)
  gatePassHistoryList: any[] = [];
  gatePassHistoryProgressing: boolean = false;
  gatePassHistoryObj: any = {};
  gatePassHistoryTableDetails: any = { "data": {}, "id": "gatepassreport", "name": 'Gate Pass Details', "Desscription": 'Gate Pass', "is_view": false };
  gatePassHistoryApprovalDetails: any = { "data": {}, "id": "gatepassreport", "name": 'Gate Pass Approval', "Desscription": 'Gate Pass', "is_view": false };
  gatePassHistoryDivDetails: any = { "data": {}, "id": "gatepassreport", "name": 'Gate Pass div Details', "Desscription": 'Gate Pass divs', "is_view": false };

  getProductMasterData(): any {
    const tableDetails = this.commonVariableList.tableDetails;
    const items = tableDetails && tableDetails.data && tableDetails.data.items;
    return items && items.length ? items[0] : null;
  }

  getProductDataForView(): any[] {
    const p = this.getProductMasterData();
    return p ? [p] : [];
  }

  is_column_visible_productmaster(key: string, b: boolean): boolean {
    const list = this.company_setup && this.company_setup.product_master_column_list;
    if (list && list.length) {
      const col = list.find(function (c) { return c.key === key; });
      return col ? (col.isVisible !== false) : true;
    }
    return true;
  }

  getColumnName_productmaster(key: string, defaultName: string): string {
    const list = this.company_setup && this.company_setup.product_master_column_list;
    if (list && list.length) {
      const col = list.find(function (c) { return c.key === key; });
      return col && col.display ? col.display : defaultName;
    }
    return defaultName;
  }

  // Master template aliases
  is_column_visible(key: string, b: boolean): boolean { return this.is_column_visible_productmaster(key, b); }
  getColumnName(key: string, defaultName: string): string { return this.getColumnName_productmaster(key, defaultName); }

  private resolveVendorMasterColumnList(): any[] {
    const master = this.company_setup && this.company_setup.master_column_list
      ? this.company_setup.master_column_list
      : [];
    if (!master || !master.length) {
      return [];
    }
    const vendorMasterBlock = master.filter((v) => { return v.id == 'vendor_master'; });
    if (vendorMasterBlock && vendorMasterBlock.length) {
      return vendorMasterBlock[0].columns ? vendorMasterBlock[0].columns : [];
    }
    // Flat list (same shape as Vendor Master screen)
    if (master[0] && master[0].key != undefined) {
      return master;
    }
    return [];
  }

  is_column_visible_vendormaster(key: string, defaultVisible?: boolean): boolean {
    const fallback = defaultVisible === true;
    if (!key) {
      return fallback;
    }
    const list = this.vendorMasterColumnList && this.vendorMasterColumnList.length
      ? this.vendorMasterColumnList
      : this.resolveVendorMasterColumnList();
    if (!list || !list.length) {
      return fallback;
    }
    const temp = list.filter((v) => { return v.key == key; });
    if (!temp || !temp.length) {
      return fallback;
    }
    if (temp[0].is_visible !== undefined && temp[0].is_visible !== null) {
      return temp[0].is_visible === true || temp[0].is_visible === '1' || temp[0].is_visible === 1;
    }
    if (temp[0].isVisible !== undefined && temp[0].isVisible !== null) {
      return temp[0].isVisible === true || temp[0].isVisible === '1' || temp[0].isVisible === 1;
    }
    return fallback;
  }

  hasVendorMasterDisplayValue(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'boolean') {
      return true;
    }
    if (typeof value === 'number') {
      return true;
    }
    if (Array.isArray(value)) {
      return value.length > 0;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed || trimmed === '-' || trimmed === '0000-00-00' || trimmed === 'NaN-NaN-NaN') {
        return false;
      }
      return true;
    }
    return true;
  }

  isVendorMasterFieldVisible(key: string, value: any, defaultVisible: boolean = false): boolean {
    if (!this.is_column_visible_vendormaster(key, defaultVisible)) {
      return false;
    }
    return this.hasVendorMasterDisplayValue(value);
  }

  isVendorMasterFieldVisibleAny(keys: string[], value: any): boolean {
    if (!keys || !keys.length) {
      return false;
    }
    const visible = keys.some((key) => { return this.is_column_visible_vendormaster(key, false); });
    if (!visible) {
      return false;
    }
    return this.hasVendorMasterDisplayValue(value);
  }

  isVendorMasterFieldVisibleByKey(key: string, defaultVisible: boolean = false): boolean {
    if (!this.is_column_visible_vendormaster(key, defaultVisible)) {
      return false;
    }
    return this.hasVendorMasterDisplayValue(this.getVendorMasterFieldValue(key));
  }

  /** Vendor Master View parity: show when setup visible (including empty values). */
  isVendorMasterViewFieldVisible(key: string, defaultVisible: boolean = false): boolean {
    return this.is_column_visible_vendormaster(key, defaultVisible);
  }

  isVendorMasterViewFieldVisibleByKey(key: string, defaultVisible: boolean = false): boolean {
    return this.is_column_visible_vendormaster(key, defaultVisible);
  }

  isVendorMasterViewFieldVisibleAny(keys: string[], defaultVisible: boolean = false): boolean {
    if (!keys || !keys.length) {
      return false;
    }
    for (let i = 0; i < keys.length; i++) {
      if (this.is_column_visible_vendormaster(keys[i], defaultVisible)) {
        return true;
      }
    }
    return false;
  }

  private readonly vendorMasterBankTaxCoreFields: string[] = [
    'bank_name', 'account_number', 'ifsc_code', 'benificiary_name', 'apply_tds'
  ];

  private getVendorMasterBankFieldAddressKeys(vendorKey: string): string[] {
    const map: any = {
      bank_name: ['bank_name_address'],
      account_number: ['account_number_address'],
      ifsc_code: ['ifsc_code_address'],
      benificiary_name: ['benificiary_name_address'],
      bank_city: ['bank_city_address'],
      bank_branch: ['bank_branch_address'],
      bank_account_type: ['bank_account_type'],
      default_tds: ['default_tds'],
      tds_code_no: ['tds_code_no'],
      tds_rate: ['tds_rate'],
      validity_amount: ['validity_amount'],
      tds_certification_no: ['tds_certification_no'],
      validity_start_date: ['validity_start_date'],
      tds_validity_date: ['tds_validity_date'],
      income_tax_type: ['income_tax_type'],
      routing_no: ['routing_no', 'bank_routing_no'],
      iban_no: ['iban_no', 'bank_iban_no'],
      swift_code: ['swift_code', 'bank_swift_code'],
    };
    return map[vendorKey] ? map[vendorKey] : [];
  }

  isVendorMasterBankTaxColumnVisible(key: string): boolean {
    const defaultVisible = this.vendorMasterBankTaxCoreFields.indexOf(key) >= 0;
    if (this.is_column_visible_vendormaster(key, defaultVisible)) {
      return true;
    }
    const aliases = this.getVendorMasterBankFieldAddressKeys(key);
    for (let i = 0; i < aliases.length; i++) {
      if (this.is_column_visible_vendormaster(aliases[i], false)) {
        return true;
      }
    }
    return false;
  }

  isVendorMasterBankTaxFieldVisibleByKey(key: string): boolean {
    if (!this.isVendorMasterBankTaxColumnVisible(key)) {
      return false;
    }
    return this.hasVendorMasterDisplayValue(this.getVendorMasterFieldValue(key));
  }

  isVendorMasterBankTaxViewFieldVisibleByKey(key: string): boolean {
    return this.isVendorMasterBankTaxColumnVisible(key);
  }

  isVendorMasterBankTaxFieldVisibleAny(keys: string[], value: any): boolean {
    if (!keys || !keys.length) {
      return false;
    }
    const visible = keys.some((key) => { return this.isVendorMasterBankTaxColumnVisible(key); });
    if (!visible) {
      return false;
    }
    if (this.hasVendorMasterDisplayValue(value)) {
      return true;
    }
    for (let i = 0; i < keys.length; i++) {
      if (this.hasVendorMasterDisplayValue(this.getVendorMasterFieldValue(keys[i]))) {
        return true;
      }
    }
    return false;
  }

  isVendorMasterBankTaxViewFieldVisibleAny(keys: string[]): boolean {
    if (!keys || !keys.length) {
      return false;
    }
    for (let i = 0; i < keys.length; i++) {
      if (this.isVendorMasterBankTaxColumnVisible(keys[i])) {
        return true;
      }
    }
    return false;
  }

  isVendorMasterPostingGroupVisible(): boolean {
    return !!(this.company_setup
      && (this.company_setup.is_vendor_posting_group_visible == '1'
        || this.company_setup.is_vendor_posting_group_visible === true));
  }

  isVendorMasterGenBusPostingGroupVisible(): boolean {
    return !!(this.company_setup
      && (this.company_setup.is_gen_bus_posting_group_visible == '1'
        || this.company_setup.is_gen_bus_posting_group_visible === true));
  }

  isVendorMasterAssesseeCodeVisible(): boolean {
    return !!(this.company_setup
      && (this.company_setup.is_assessee_code_visible == '1'
        || this.company_setup.is_assessee_code_visible === true));
  }

  private getVendorMasterPrimaryAddress(vendor: any): any {
    if (!vendor || !vendor.address_details || !vendor.address_details.length) {
      return null;
    }
    const primary = vendor.address_details.filter((a: any) => {
      return a.is_primary == '1' || a.is_primary === 1 || a.is_primary === true;
    });
    return primary.length ? primary[0] : vendor.address_details[0];
  }

  private copyVendorMasterFieldIfEmpty(vendor: any, loc: any, vendorKey: string, locKey?: string): void {
    if (!vendor || !loc) {
      return;
    }
    const sourceKey = locKey ? locKey : vendorKey;
    if (!this.hasVendorMasterDisplayValue(vendor[vendorKey]) && this.hasVendorMasterDisplayValue(loc[sourceKey])) {
      vendor[vendorKey] = loc[sourceKey];
    }
  }

  private hydrateVendorMasterBankTaxFromAddress(vendor: any): void {
    const loc = this.getVendorMasterPrimaryAddress(vendor);
    if (!loc) {
      return;
    }
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_name');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'account_number');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'account_number', 'account_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'account_number', 'bank_account_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'ifsc_code');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'benificiary_name');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_city');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_branch');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_account_type');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'routing_no', 'bank_routing_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_routing_no', 'bank_routing_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'iban_no', 'bank_iban_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_iban_no', 'bank_iban_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'swift_code', 'bank_swift_code');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'bank_swift_code', 'bank_swift_code');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'default_tds');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'default_tds_name');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'tds_code_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'tds_rate');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'validity_amount');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'tds_certification_no');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'validity_start_date');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'tds_validity_date');
    this.copyVendorMasterFieldIfEmpty(vendor, loc, 'income_tax_type');
    if ((!vendor.withholding_tax_type_label || !vendor.withholding_tax_type_label.length)
      && this.hasVendorMasterDisplayValue(loc.withholding_tax_type_display)) {
      vendor.withholding_tax_type_label = [loc.withholding_tax_type_display];
    }
    if ((!vendor.withholding_tax_code_label || !vendor.withholding_tax_code_label.length)
      && this.hasVendorMasterDisplayValue(loc.withholding_tax_code_display)) {
      vendor.withholding_tax_code_label = [loc.withholding_tax_code_display];
    }
  }

  private getVendorMasterAddressFieldFallback(vendor: any, vendorKey: string, locKey?: string): any {
    const loc = this.getVendorMasterPrimaryAddress(vendor);
    if (!loc) {
      return null;
    }
    const sourceKey = locKey ? locKey : vendorKey;
    return loc[sourceKey];
  }

  getVendorMasterFieldValue(key: string): any {
    const vendor = this.vendorMasterData;
    if (!vendor || !key) {
      return null;
    }
    switch (key) {
      case 'salutation':
        return vendor.salutation_display || vendor.salutation || vendor.Salutation_id;
      case 'gender':
        return vendor.gender_display || vendor.gender;
      case 'payment_term':
        return vendor.payment_term_display || vendor.payment_term_name || vendor.payment_term;
      case 'detailed_payment_terms':
        return vendor.detailed_payment_terms_display;
      case 'vendor_type':
        return vendor.vendor_type_display || vendor.vendor_type_name || vendor.vendor_type;
      case 'msme_type':
        return vendor.msme_type_display || vendor.msme_type;
      case 'entity_type':
        return this.getVendorMasterEntityType(vendor.entity_type);
      case 'vendor_category':
        return this.getVendorMasterEntityType(vendor.vendor_category) || vendor.vendor_category;
      case 'material_nature':
        return this.getVendorMasterMaterialNature(vendor.material_nature);
      case 'country_name':
      case 'country':
        return vendor.country_name || vendor.country;
      case 'state_name':
      case 'state_id':
        return vendor.state_name || vendor.state_id;
      case 'city_name':
      case 'city_id':
        return vendor.city_name || vendor.city_id;
      case 'district':
      case 'district_id':
        return vendor.district_display || vendor.district_name || vendor.district;
      case 'account_name':
        return vendor.account_name
          ? (vendor.account_name + (vendor.account_code ? (' (' + vendor.account_code + ')') : ''))
          : vendor.account_code;
      case 'showApply_tds':
        return vendor.showApply_tds != undefined ? vendor.showApply_tds : vendor.apply_tds;
      case 'is_agreement':
      case 'show_Agreement':
        return vendor.show_Agreement != undefined ? vendor.show_Agreement : vendor.is_agreement;
      case 'relation_type':
        return this.isVendorMasterFlagYes(vendor.related_party) ? vendor.relation_type_display : '';
      case 'auto_debit_source':
        return this.isVendorMasterFlagYes(vendor.is_auto_debit_vendor) ? vendor.auto_debit_source_display : '';
      case 'override_direct_inv_limit':
        return this.isVendorMasterFlagYes(
          vendor.show_Agreement != undefined ? vendor.show_Agreement : vendor.is_agreement
        ) ? vendor.override_direct_inv_limit : '';
      case 'vendor_ranking':
        return vendor.vendor_ranking_category || vendor.vendor_ranking || vendor.vendor_question_ranking;
      case 'vendor_group':
        return vendor.vendor_group_display || vendor.vendor_group_name;
      case 'default_tds':
        return vendor.default_tds_display || vendor.default_tds_name || vendor.default_tds
          || this.getVendorMasterAddressFieldFallback(vendor, 'default_tds_name')
          || this.getVendorMasterAddressFieldFallback(vendor, 'default_tds');
      case 'reporting_currency':
        return vendor.reporting_currency_display || vendor.reporting_currency_name
          || vendor.reporting_currency_code || vendor.reporting_currency;
      case 'routing_no':
      case 'bank_routing_no':
        return vendor.routing_no || vendor.bank_routing_no
          || this.getVendorMasterAddressFieldFallback(vendor, 'bank_routing_no');
      case 'iban_no':
      case 'bank_iban_no':
        return vendor.iban_no || vendor.bank_iban_no
          || this.getVendorMasterAddressFieldFallback(vendor, 'bank_iban_no');
      case 'swift_code':
      case 'bank_swift_code':
        return vendor.swift_code || vendor.bank_swift_code
          || this.getVendorMasterAddressFieldFallback(vendor, 'bank_swift_code');
      case 'account_number':
        return vendor.account_number || vendor.bank_account_no
          || this.getVendorMasterAddressFieldFallback(vendor, 'account_number')
          || this.getVendorMasterAddressFieldFallback(vendor, 'account_no')
          || this.getVendorMasterAddressFieldFallback(vendor, 'bank_account_no');
      case 'bank_name':
        return vendor.bank_name || this.getVendorMasterAddressFieldFallback(vendor, 'bank_name');
      case 'ifsc_code':
        return vendor.ifsc_code || this.getVendorMasterAddressFieldFallback(vendor, 'ifsc_code');
      case 'benificiary_name':
        return vendor.benificiary_name || this.getVendorMasterAddressFieldFallback(vendor, 'benificiary_name');
      case 'bank_city':
        return vendor.bank_city || this.getVendorMasterAddressFieldFallback(vendor, 'bank_city');
      case 'bank_branch':
        return vendor.bank_branch || this.getVendorMasterAddressFieldFallback(vendor, 'bank_branch');
      case 'apply_tds':
        return vendor.apply_tds != undefined && vendor.apply_tds !== null
          ? vendor.apply_tds
          : vendor.showApply_tds;
      case 'tds_code_no':
        return vendor.tds_code_no || this.getVendorMasterAddressFieldFallback(vendor, 'tds_code_no');
      case 'tds_rate':
        return vendor.tds_rate || this.getVendorMasterAddressFieldFallback(vendor, 'tds_rate');
      case 'validity_amount':
        return vendor.validity_amount || this.getVendorMasterAddressFieldFallback(vendor, 'validity_amount');
      case 'tds_certification_no':
        return vendor.tds_certification_no || this.getVendorMasterAddressFieldFallback(vendor, 'tds_certification_no');
      case 'income_tax_type':
        return vendor.income_tax_type_display || vendor.income_tax_type_name || vendor.income_tax_type;
      case 'bank_account_type':
        return vendor.bank_account_type_display || vendor.bank_account_type_name || vendor.bank_account_type
          || this.getVendorMasterAddressFieldFallback(vendor, 'bank_account_type');
      case 'msme_start_date':
        return vendor.msme_start_date_display;
      case 'msme_end_date':
        return vendor.msme_end_date_display;
      case 'fssai_validity_date':
        return vendor.fssai_validity_date_display;
      case 'validity_start_date':
        return vendor.validity_start_date_display;
      case 'tds_validity_date':
        return vendor.tds_validity_date_display;
      case 'default_document_currency':
        return vendor.default_document_currency_display;
      case 'withholding_tax_type':
        return vendor.withholding_tax_type_label;
      case 'withholding_tax_code':
        return vendor.withholding_tax_code_label;
      case 'federal_tax':
        return vendor.federal_tax;
      case 'add_multiple_vendor_contact_details':
        return vendor.is_multiple_vendor_contact_details;
      case 'company_role':
        return vendor.vendor_roles_display;
      case 'product_sub_category':
        return vendor.product_sub_category_display;
      case 'restrict_vendor_for':
        return vendor.restrict_vendor_for_display;
      case 'vendor_question_ranking':
        return vendor.vendor_question_ranking || vendor.vendor_ranking_category;
      case 'rfi_dating_date':
        return vendor.rfi_dating_date_display || vendor.vendor_questionnaire_detail;
      case 'vendor_posting_group':
        return vendor.vendor_posting_group;
      case 'gen_bus_posting_group':
        return vendor.gen_bus_posting_group;
      case 'assessee_code':
        return vendor.assessee_code;
      case 'common_bank_details':
      case 'common_bank_details_required_for_location_level_or_not':
        return vendor.common_bank_details;
      case 'advance_vendor':
        return vendor.is_advance_vendor;
      case 'receipt_required':
        return vendor.receipt_required;
      case 'matching_type':
        return vendor.matching_type_display || vendor.matching_type;
      case 'purchasing_organization':
        return vendor.purchasing_org_display;
      case 'lob_dropdown':
        return vendor.lob_display;
      case 'address_time_zone':
        return vendor.address_time_zone_display;
      case 'incoterm_code':
        return vendor.incoterm_display;
      case 'payment_methods':
        return vendor.payment_method_display;
      case 'prepay_code':
        return vendor.prepay_code_display || vendor.prepay_code;
      case 'payment_file_format':
      case 'netsuite_payment_file_format':
        return vendor.payment_file_format_display
          || vendor.payment_file_format
          || vendor.netsuite_payment_file_format;
      case 'field_1':
        return vendor.field_1;
      case 'field_2':
        return vendor.field_2;
      default:
        return vendor[key];
    }
  }

  private getVendorMasterTabFieldKeys(tab: number): string[] {
    switch (tab) {
      case 1:
        return [
          'vendor_code', 'first_name', 'salutation', 'middle_name', 'last_name', 'vendor_nick_name', 'email', 'mobile',
          'gender', 'pan_number', 'pan_na', 'gst_reg_master', 'gst_in_number', 'msme', 'msme_registration_no',
          'msme_start_date', 'msme_end_date', 'msme_type', 'entity_type', 'vendor_category', 'country_name', 'state_name',
          'city_name', 'district', 'pincode', 'address', 'excise_registration_no', 'VAT_number', 'lst', 'lbt',
          'vendor_type', 'lead_time', 'federal_tax', 'material_nature',
          'fssai_no', 'fssai_validity_date', 'adhar_no', 'tan', 'cin', 'pf', 'esi', 'website'
        ];
      case 2:
        return [
          'account_name', 'credit_period', 'credit_amount', 'payment_term', 'detailed_payment_terms', 'blacklisted',
          'hold_payments', 'is_active', 'is_agreement', 'related_party', 'relation_type', 'showApply_tds', 'is_logistic',
          'is_volume_discount', 'discount_early', 'is_asset_service_vendor', 'e_invoice_applicable', 'gst_defaulted',
          'section_206ab_verified', 'open_contract', 'common_bank_details', 'send_vendor_login_details',
          'is_auto_debit_vendor', 'auto_debit_source', 'override_direct_inv_limit', 'add_multiple_vendor_contact_details',
          'is_credit_card_vendor', 'client_erp_code', 'erp_status', 'erp_code', 'vendor_ranking', 'vendor_group',
          'location_code', 'no_of_location', 'remarks',
          'advance_vendor', 'receipt_required', 'matching_type', 'purchasing_organization', 'lob_dropdown',
          'address_time_zone', 'incoterm_code', 'payment_methods', 'prepay_code', 'field_1', 'field_2',
          'company_role', 'product_sub_category', 'restrict_vendor_for',
          'vendor_question_ranking', 'rfi_dating_date'
        ];
      case 3:
        return [
          'bank_name', 'account_number', 'ifsc_code', 'benificiary_name', 'bank_city', 'bank_branch', 'bank_account_type',
          'routing_no', 'iban_no', 'swift_code', 'income_tax_type', 'apply_tds', 'tds_code_no', 'tds_rate',
          'validity_amount', 'tds_certification_no', 'validity_start_date', 'tds_validity_date', 'default_tds',
          'withholding_tax_type', 'withholding_tax_code', 'default_document_currency',
          'reporting_currency', 'payment_file_format'
        ];
      default:
        return [];
    }
  }

  hasVendorMasterContactsSection(): boolean {
    return !!(this.vendorMasterData && this.vendorMasterData.vendor_contact_details
      && this.vendorMasterData.vendor_contact_details.length);
  }

  hasVendorMasterAddressSection(): boolean {
    return !!(this.vendorMasterData && this.vendorMasterData.address_details
      && this.vendorMasterData.address_details.length);
  }

  hasVendorMasterAgreementsSection(): boolean {
    return !!(this.vendorMasterData && this.vendorMasterData.agreement_details
      && this.vendorMasterData.agreement_details.length);
  }

  hasVendorMasterTabFieldsContent(tab: number): boolean {
    if (!this.vendorMasterData) {
      return false;
    }
    if (tab === 3) {
      const keys = this.getVendorMasterTabFieldKeys(3);
      for (let i = 0; i < keys.length; i++) {
        if (this.isVendorMasterBankTaxViewFieldVisibleByKey(keys[i])) {
          return true;
        }
      }
      return false;
    }
    if (tab === 1) {
      if (this.isVendorMasterFederalTaxVisible()) {
        return true;
      }
    }
    const keys = this.getVendorMasterTabFieldKeys(tab);
    for (let i = 0; i < keys.length; i++) {
      if (this.isVendorMasterViewFieldVisibleByKey(keys[i])) {
        return true;
      }
    }
    return false;
  }

  hasVendorMasterTabContent(tab: number): boolean {
    switch (tab) {
      case 4:
        return this.hasVendorMasterContactsSection() || this.hasVendorMasterAddressSection();
      case 5:
        return this.hasVendorMasterDocumentsTabContent() || this.hasVendorMasterApproverSection();
      case 2:
        return this.hasVendorMasterTabFieldsContent(2) || this.hasVendorMasterAgreementsSection();
      default:
        return this.hasVendorMasterTabFieldsContent(tab);
    }
  }

  hasVendorMasterAnyTabContent(): boolean {
    for (let tab = 1; tab <= 5; tab++) {
      if (this.hasVendorMasterTabContent(tab)) {
        return true;
      }
    }
    return false;
  }

  private adjustVendorMasterActiveTab(): void {
    if (this.hasVendorMasterTabContent(this.vendorMasterActiveTab)) {
      return;
    }
    for (let tab = 1; tab <= 5; tab++) {
      if (this.hasVendorMasterTabContent(tab)) {
        this.vendorMasterActiveTab = tab;
        return;
      }
    }
    this.vendorMasterActiveTab = 1;
  }

  getVendorMasterSalutationDisplay(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const list = (this.company_setup && this.company_setup.salutation_master_list)
      ? this.company_setup.salutation_master_list
      : [];
    if (list && list.length) {
      const matched = list.filter((sal: any) => {
        return sal.salutation_code == value
          || sal.salutation_name == value
          || sal.id == value;
      });
      if (matched.length) {
        return matched[0].salutation_name || matched[0].salutation_code || String(value);
      }
    }
    return String(value);
  }

  getVendorMasterGenderDisplay(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    if (value == 'M' || value == 'm') {
      return 'Male';
    }
    if (value == 'F' || value == 'f') {
      return 'Female';
    }
    return String(value);
  }

  getColumnName_vendormaster(key: string, defaultName: string): string {
    if (!key) {
      return defaultName ? defaultName : '-';
    }
    const list = this.vendorMasterColumnList && this.vendorMasterColumnList.length
      ? this.vendorMasterColumnList
      : this.resolveVendorMasterColumnList();
    if (!list || !list.length) {
      return defaultName ? defaultName : '-';
    }
    const temp = list.filter((v) => { return v.key == key; });
    if (!temp || !temp.length) {
      return defaultName ? defaultName : '-';
    }
    return temp[0].custom_name
      ? temp[0].custom_name
      : (temp[0].display ? temp[0].display : (defaultName ? defaultName : '-'));
  }

  private normalizeVendorAttachmentList(list: any): any[] {
    if (!list || !list.length) {
      return [];
    }
    return list.map((a) => {
      const filename = a.filename
        ? a.filename
        : (a.attachment_name ? a.attachment_name : (a.file_name ? a.file_name : (a.name ? a.name : '')));
      const display = a.display
        ? a.display
        : (a.attachments_url
          ? a.attachments_url
          : (a.attachment_url
            ? a.attachment_url
            : (a.url ? a.url : (a.attachment ? a.attachment : ''))));
      const ext = this.webService.getFileExtension(display ? display : filename);
      return {
        filename: filename,
        display: display,
        url: display,
        attachment: display,
        document_type: a.document_type ? a.document_type : (a.key ? a.key : 'doc'),
        key: a.key ? a.key : '',
        iconclass: this.webService.getFileIcon(ext ? ext : ''),
      };
    }).filter((a) => { return a.display || a.filename; });
  }

  private buildVendorMasterDocumentBuckets(rawAttachments: any[]) {
    this.vendorMasterAttachments = [];
    this.vendorMasterPanFiles = [];
    this.vendorMasterGstFiles = [];
    this.vendorMasterMsmeFiles = [];
    this.vendorMasterEInvoiceFiles = [];
    this.vendorMasterSectionFiles = [];
    const list = this.normalizeVendorAttachmentList(rawAttachments ? rawAttachments : []);
    for (let d of list) {
      const type = d.document_type ? String(d.document_type).toLowerCase() : 'doc';
      if (type == 'pan') {
        this.vendorMasterPanFiles.push(d);
      } else if (type == 'gst') {
        this.vendorMasterGstFiles.push(d);
      } else if (type == 'msme') {
        this.vendorMasterMsmeFiles.push(d);
      } else if (type == 'e-invoice' || type == 'einvoice') {
        this.vendorMasterEInvoiceFiles.push(d);
      } else if (type == 'section') {
        this.vendorMasterSectionFiles.push(d);
      } else {
        // Master default bucket = Upload PAN/GST/Cancel cheque (document_type blank/'doc')
        this.vendorMasterAttachments.push(d);
      }
    }
  }

  private buildVendorMasterAdditionalDocumentRows(vendor: any) {
    this.vendorMasterAdditionalDocumentRows = [];
    this.vendorMasterShowExpiryInDocs = false;
    this.vendorMasterShowRemarksInDocs = false;
    const setupDocs = (this.company_setup && this.company_setup.vendor_documents)
      ? this.company_setup.vendor_documents.filter((v) => { return v && v.is_view; })
      : [];
    for (let s of setupDocs) {
      if (s.expiry_date_visible) {
        this.vendorMasterShowExpiryInDocs = true;
      }
      if (s.remarks_visible) {
        this.vendorMasterShowRemarksInDocs = true;
      }
    }
    let apiDocs: any[] = vendor.additional_vendor_documents
      ? vendor.additional_vendor_documents
      : (vendor.additional_documents ? vendor.additional_documents : []);
    apiDocs = apiDocs ? apiDocs : [];

    // Prefer structured rows (key/display + attachment). If flat file list only, show as one row.
    const looksStructured = apiDocs.some((d) => {
      return d && (d.key || d.display || d.attachment_name || d.attachment_url || d.additional_savedFiles);
    });

    if (!looksStructured && apiDocs.length) {
      const files = this.normalizeVendorAttachmentList(apiDocs);
      if (files.length) {
        this.vendorMasterAdditionalDocumentRows = [{
          display: 'Additional Documents',
          key: 'additional_documents',
          additional_savedFiles: files,
          expiry_date: '',
          remarks: '',
          expiry_date_visible: false,
          remarks_visible: false,
        }];
      }
      this.vendorMasterAdditionalDocuments = files;
      return;
    }

    const rowsByKey: any = {};
    const pushFileToRow = (row: any, fileSrc: any) => {
      const files = this.normalizeVendorAttachmentList([fileSrc]);
      if (!files.length) {
        return;
      }
      row.additional_savedFiles = row.additional_savedFiles.concat(files);
    };

    // Seed from setup so Name column matches Master
    for (let s of setupDocs) {
      rowsByKey[s.key] = {
        display: s.display ? s.display : (s.custom_name ? s.custom_name : s.key),
        key: s.key,
        is_mandatory: s.is_mandatory ? s.is_mandatory : false,
        additional_savedFiles: [],
        expiry_date: '',
        remarks: '',
        expiry_date_visible: !!s.expiry_date_visible,
        remarks_visible: !!s.remarks_visible,
      };
    }

    for (let d of apiDocs) {
      if (!d) { continue; }
      // Already-normalized nested files
      if (d.additional_savedFiles && d.additional_savedFiles.length) {
        const key = d.key ? d.key : ('row_' + this.vendorMasterAdditionalDocumentRows.length);
        if (!rowsByKey[key]) {
          rowsByKey[key] = {
            display: d.display ? d.display : key,
            key: key,
            additional_savedFiles: [],
            expiry_date: d.expiry_date ? d.expiry_date : '',
            remarks: d.remarks ? d.remarks : '',
            expiry_date_visible: !!d.expiry_date_visible,
            remarks_visible: !!d.remarks_visible,
          };
        }
        rowsByKey[key].additional_savedFiles = rowsByKey[key].additional_savedFiles.concat(
          this.normalizeVendorAttachmentList(d.additional_savedFiles)
        );
        if (d.expiry_date) { rowsByKey[key].expiry_date = d.expiry_date; }
        if (d.remarks) { rowsByKey[key].remarks = d.remarks; }
        continue;
      }

      const key = d.key ? d.key : '';
      const attachmentUrl = d.attachment_url
        ? d.attachment_url
        : (d.attachment ? d.attachment : (d.attachments_url ? d.attachments_url : (d.display && d.filename ? d.display : '')));
      if (!key && !attachmentUrl) {
        continue;
      }
      if (!rowsByKey[key || attachmentUrl]) {
        rowsByKey[key || attachmentUrl] = {
          display: d.display
            ? d.display
            : (d.attachment_name ? d.attachment_name : (key || 'Document')),
          key: key || attachmentUrl,
          additional_savedFiles: [],
          expiry_date: d.expiry_date ? d.expiry_date : '',
          remarks: d.remarks ? d.remarks : '',
          expiry_date_visible: !!d.expiry_date_visible,
          remarks_visible: !!d.remarks_visible,
        };
      }
      if (attachmentUrl || d.attachment_name) {
        pushFileToRow(rowsByKey[key || attachmentUrl], {
          display: attachmentUrl,
          attachments_url: attachmentUrl,
          attachment_name: d.attachment_name ? d.attachment_name : d.filename,
          filename: d.attachment_name ? d.attachment_name : d.filename,
          attachment: attachmentUrl,
        });
      }
      if (d.expiry_date) {
        rowsByKey[key || attachmentUrl].expiry_date = d.expiry_date;
        rowsByKey[key || attachmentUrl].expiry_date_visible = true;
      }
      if (d.remarks) {
        rowsByKey[key || attachmentUrl].remarks = d.remarks;
        rowsByKey[key || attachmentUrl].remarks_visible = true;
      }
    }

    const rows: any[] = [];
    for (let k of Object.keys(rowsByKey)) {
      const row = rowsByKey[k];
      // In view popup show rows that have files, or setup-defined rows with files only (cleaner)
      if (row.additional_savedFiles && row.additional_savedFiles.length) {
        rows.push(row);
        if (row.expiry_date_visible || row.expiry_date) { this.vendorMasterShowExpiryInDocs = true; }
        if (row.remarks_visible || row.remarks) { this.vendorMasterShowRemarksInDocs = true; }
      }
    }
    this.vendorMasterAdditionalDocumentRows = rows;
    this.vendorMasterAdditionalDocuments = [];
    for (let r of rows) {
      this.vendorMasterAdditionalDocuments = this.vendorMasterAdditionalDocuments.concat(r.additional_savedFiles);
    }
  }

  showVendorMaster(data: any) {
    this.commonVariableList.isProgressing = true;
    this.vendorMasterData = {};
    this.vendorMasterAttachments = [];
    this.vendorMasterPanFiles = [];
    this.vendorMasterGstFiles = [];
    this.vendorMasterMsmeFiles = [];
    this.vendorMasterEInvoiceFiles = [];
    this.vendorMasterSectionFiles = [];
    this.vendorMasterAgreementAttachments = [];
    this.vendorMasterAdditionalDocuments = [];
    this.vendorMasterAdditionalDocumentRows = [];
    this.vendorMasterLocationAttachments = [];
    this.vendorMasterShowExpiryInDocs = false;
    this.vendorMasterShowRemarksInDocs = false;
    this.vendorMasterActiveTab = 1;
    this.vendorMasterColumnList = this.resolveVendorMasterColumnList();

    let vendorId = data && (data.vendor_id || data.ven_id || data.id)
      ? (data.vendor_id || data.ven_id || data.id)
      : '';
    // Support composite ids like vendorId_locationId from invoice screens
    if (vendorId && vendorId.toString().indexOf('_') > -1) {
      vendorId = vendorId.toString().split('_')[0];
    }
    if (!vendorId) {
      this.commonVariableList.isProgressing = false;
      this.toasterService.pop('info', 'Info', 'Vendor details not found');
      return;
    }

    // Use company vendor list API (same as Vendor Master / agreement view).
    // vendors_by_id_v2 often returns empty for approved master vendors.
    const payload: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      user_id: this._localStorageService.getUserId() == undefined ? '0' : this._localStorageService.getUserId(),
      vendor_id_filter_require: '1',
      vendor_id: vendorId,
    };

    this.webService.commonPostMethod('/vendors/ajax_vendors_by_company_v2', payload).subscribe(
      (resp) => {
        if (resp && resp.status) {
          let list: any = resp.response
            ? resp.response
            : (resp.data ? resp.data : []);
          if (!list || list.length == undefined) {
            list = list ? [list] : [];
          }
          let vendor: any = {};
          if (list && list.length) {
            const matched = list.filter((v) => {
              return v && (v.vendor_id == vendorId || v.ven_id == vendorId || v.user_id == vendorId);
            });
            vendor = matched.length ? matched[0] : list[0];
          }
          vendor = vendor ? vendor : {};
          if (!vendor.vendor_id && !vendor.ven_id) {
            this.commonVariableList.isProgressing = false;
            this.toasterService.pop('info', 'Info', 'No vendor data found');
            return;
          }
          // Never expose password in read-only popup
          if (vendor.password != undefined) {
            delete vendor.password;
          }
          vendor.address_details = vendor.address_details ? vendor.address_details : [];
          vendor.agreement_details = vendor.agreement_details ? vendor.agreement_details : [];
          vendor.vendor_approval = vendor.vendor_approval ? vendor.vendor_approval : [];
          vendor.vendor_contact_details = vendor.vendor_contact_details ? vendor.vendor_contact_details : [];
          vendor.withholding_tax_type_label = vendor.withholding_tax_type_label
            ? vendor.withholding_tax_type_label
            : (vendor.withholding_tax_type ? vendor.withholding_tax_type : []);
          vendor.withholding_tax_code_label = vendor.withholding_tax_code_label
            ? vendor.withholding_tax_code_label
            : (vendor.withholding_tax_code ? vendor.withholding_tax_code : []);
          // Build Approver display list (same shape as Vendor Master View)
          this.normalizeVendorMasterApprovalRows(vendor);
          if (vendor.address_details && vendor.address_details.length) {
            for (let loc of vendor.address_details) {
              this.normalizeVendorMasterAddressRow(loc);
            }
          }
          if (vendor.agreement_details && vendor.agreement_details.length) {
            for (let agr of vendor.agreement_details) {
              this.normalizeVendorMasterAgreementRow(agr);
            }
          }
          this.normalizeVendorMasterViewData(vendor);
          this.vendorMasterData = vendor;
          this.isViewMode = true;

          // Match Vendor Master View: split attachments by document_type + additional docs table
          this.buildVendorMasterDocumentBuckets(vendor.attachments ? vendor.attachments : []);
          this.vendorMasterAgreementAttachments = this.normalizeVendorAttachmentList(
            vendor.agreement_attachments ? vendor.agreement_attachments : []
          );
          this.buildVendorMasterAdditionalDocumentRows(vendor);

          let locationAtts: any[] = [];
          if (vendor.address_details && vendor.address_details.length) {
            for (let loc of vendor.address_details) {
              const locFiles = this.normalizeVendorAttachmentList(
                loc.location_attachments ? loc.location_attachments : []
              );
              if (locFiles && locFiles.length) {
                locationAtts = locationAtts.concat(locFiles);
              }
            }
          }
          this.vendorMasterLocationAttachments = locationAtts;
          this.adjustVendorMasterActiveTab();

          this.commonVariableList.attachments = this.vendorMasterAttachments;
          this.commonVariableList.tableDetails = {
            id: 'vendormaster',
            is_setup: true,
            setup: this.company_setup,
            data: {},
          };
          this.commonVariableList.beforeDivDetails = { is_setup: false, setup: {}, is_view: false };
          this.commonVariableList.afterDivDetails = { is_setup: false, setup: {}, is_view: false };
          this.commonVariableList.approvalDetails = { is_setup: false, setup: {}, is_view: false };
        } else {
          this.toasterService.pop(
            'error',
            'Error',
            resp && resp.message ? resp.message : 'No vendor data found'
          );
        }
        this.commonVariableList.isProgressing = false;
      },
      (error) => {
        this.commonVariableList.isProgressing = false;
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  setVendorMasterTab(tab: number) {
    this.vendorMasterActiveTab = tab;
  }

  getVendorMasterDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    if (Array.isArray(value) && !value.length) {
      return '-';
    }
    return String(value);
  }

  formatVendorMasterNamedList(list: any, nameKey: string = 'name'): string {
    if (!list) {
      return '';
    }
    if (typeof list === 'string') {
      return list;
    }
    if (!list.length) {
      return '';
    }
    return list.map((item) => {
      if (item == null) {
        return '';
      }
      if (typeof item === 'string' || typeof item === 'number') {
        return String(item);
      }
      return item[nameKey]
        || item.display
        || item.name
        || item.organization_description
        || item.displayText
        || item.category_name
        || '';
    }).filter((v) => { return v; }).join(', ');
  }

  isVendorMasterFederalTaxVisible(): boolean {
    if (!this.vendorMasterData) {
      return false;
    }
    const countryId = this.vendorMasterData.country_id;
    return this.isVendorMasterViewFieldVisibleByKey('federal_tax', false)
      && countryId != '101'
      && countryId != 101;
  }

  showVendorMasterSection206Files(): boolean {
    if (!this.is_column_visible_vendormaster('section_206_document', false)) {
      return false;
    }
    if (!this.vendorMasterSectionFiles || !this.vendorMasterSectionFiles.length) {
      return false;
    }
    if (!this.vendorMasterData) {
      return true;
    }
    const verified = this.vendorMasterData.section_206ab_verified;
    return verified == '1' || verified === 1 || verified === true;
  }

  showVendorMasterUploadPanGstChequeFiles(): boolean {
    return this.is_column_visible_vendormaster('upload_pan_gst_cancel_cheque', false)
      && !!(this.vendorMasterAttachments && this.vendorMasterAttachments.length);
  }

  showVendorMasterPanDocumentFiles(): boolean {
    if (!this.is_column_visible_vendormaster('pan_document', false)) {
      return false;
    }
    if (!this.vendorMasterPanFiles || !this.vendorMasterPanFiles.length) {
      return false;
    }
    if (!this.vendorMasterData) {
      return true;
    }
    const pan = this.vendorMasterData.pan_number ? String(this.vendorMasterData.pan_number) : '';
    return pan.length === 10 && !this.isVendorMasterFlagYes(this.vendorMasterData.pan_na);
  }

  showVendorMasterGstDocumentFiles(): boolean {
    if (!this.is_column_visible_vendormaster('gst_document', false)) {
      return false;
    }
    if (!this.vendorMasterGstFiles || !this.vendorMasterGstFiles.length) {
      return false;
    }
    if (!this.vendorMasterData) {
      return true;
    }
    return this.vendorMasterData.gst_reg_master == 'GST Registered';
  }

  showVendorMasterMsmeDocumentFiles(): boolean {
    if (!this.is_column_visible_vendormaster('msme_document', false)) {
      return false;
    }
    if (!this.vendorMasterMsmeFiles || !this.vendorMasterMsmeFiles.length) {
      return false;
    }
    if (!this.vendorMasterData) {
      return true;
    }
    return this.isVendorMasterFlagYes(this.vendorMasterData.msme);
  }

  showVendorMasterEInvoiceDeclarationFiles(): boolean {
    if (!this.is_column_visible_vendormaster('attach_e_invoice_declaration', false)) {
      return false;
    }
    if (!this.vendorMasterEInvoiceFiles || !this.vendorMasterEInvoiceFiles.length) {
      return false;
    }
    if (!this.vendorMasterData) {
      return true;
    }
    const applicable = this.vendorMasterData.e_invoice_applicable;
    return applicable == '0' || applicable === 0 || applicable === false;
  }

  showVendorMasterAgreementAttachmentSection(): boolean {
    return this.is_column_visible_vendormaster('agreement_attachments', false)
      && !!(this.vendorMasterAgreementAttachments && this.vendorMasterAgreementAttachments.length);
  }

  showVendorMasterLocationAttachmentSection(): boolean {
    return this.is_column_visible_vendormaster('location_attachments', false)
      && !!(this.vendorMasterLocationAttachments && this.vendorMasterLocationAttachments.length);
  }

  showVendorMasterAdditionalDocumentsTable(): boolean {
    return !!(this.vendorMasterAdditionalDocumentRows && this.vendorMasterAdditionalDocumentRows.length);
  }

  hasVendorMasterDocumentsTabContent(): boolean {
    return this.showVendorMasterUploadPanGstChequeFiles()
      || this.showVendorMasterPanDocumentFiles()
      || this.showVendorMasterGstDocumentFiles()
      || this.showVendorMasterMsmeDocumentFiles()
      || this.showVendorMasterEInvoiceDeclarationFiles()
      || this.showVendorMasterSection206Files()
      || this.showVendorMasterAgreementAttachmentSection()
      || this.showVendorMasterLocationAttachmentSection()
      || this.showVendorMasterAdditionalDocumentsTable();
  }

  hasVendorMasterMainAttachmentBuckets(): boolean {
    return this.showVendorMasterUploadPanGstChequeFiles()
      || this.showVendorMasterPanDocumentFiles()
      || this.showVendorMasterGstDocumentFiles()
      || this.showVendorMasterMsmeDocumentFiles()
      || this.showVendorMasterEInvoiceDeclarationFiles()
      || this.showVendorMasterSection206Files();
  }

  hasVendorMasterApproverSection(): boolean {
    return !!(this.vendorMasterData && (
      (this.vendorMasterData.vendor_approval && this.vendorMasterData.vendor_approval.length)
      || this.vendorMasterData.vendor_last_approved_by
    ));
  }

  getVendorMasterDateFormat(): string {
    const fmt = this.company_setup && this.company_setup.in_invoice_date_format
      ? this.company_setup.in_invoice_date_format
      : 'dd-MM-yyyy';
    return fmt.replace(/mm/g, 'MM');
  }

  getVendorMasterApprovalLevel(row: any, index: number): string {
    if (!row) {
      return String(index + 1);
    }
    return row.employee_level ? String(row.employee_level) : String(index + 1);
  }

  isVendorMasterApprovalFinalized(status: any): boolean {
    return status != 0 && status != '0' && status != null && status != undefined && status !== '';
  }

  private normalizeVendorMasterApprovalRows(vendor: any): void {
    if (!vendor || !vendor.vendor_approval || !vendor.vendor_approval.length) {
      return;
    }
    for (let a of vendor.vendor_approval) {
      a.approval_first_name = a.approval_first_name ? a.approval_first_name : (a.first_name ? a.first_name : '');
      a.approval_last_name = a.approval_last_name ? a.approval_last_name : (a.last_name ? a.last_name : '');
      a.employee_code = a.employee_code ? a.employee_code : '';
      a.employee_level = a.employee_level ? a.employee_level : '';
      a.approval_status = a.approval_status != undefined && a.approval_status != null ? a.approval_status : '';
      a.reason = a.reason ? a.reason : '';
      a.date_added = a.date_added ? a.date_added : (a.requested_date ? a.requested_date : '');
      a.date_updated = a.date_updated ? a.date_updated : (a.approved_date ? a.approved_date : '');
      a.approval_status_label = this.getVendorMasterApprovalStatus(a.approval_status);
    }
  }

  private normalizeVendorMasterViewData(vendor: any): void {
    if (!vendor) {
      return;
    }
    this.hydrateVendorMasterBankTaxFromAddress(vendor);
    vendor.vendor_question_ranking = vendor.vendor_ranking_category
      || vendor.vendor_question_ranking
      || '';
    vendor.salutation_display = vendor.salutation_name
      || this.getVendorMasterSalutationDisplay(vendor.salutation || vendor.Salutation_id);
    vendor.gender_display = vendor.gender_name || this.getVendorMasterGenderDisplay(vendor.gender);
    vendor.payment_term_display = vendor.payment_term_name
      || vendor.payment_terms_name
      || vendor.payment_term;
    vendor.vendor_type_display = vendor.vendor_type_name || vendor.vendor_type;
    vendor.msme_type_display = vendor.msme_type_name || vendor.msme_type;
    vendor.income_tax_type_display = vendor.income_tax_type_name || vendor.income_tax_type;
    vendor.bank_account_type_display = vendor.bank_account_type_name || vendor.bank_account_type;
    vendor.default_tds_display = vendor.default_tds_name || vendor.default_tds;
    vendor.reporting_currency_display = vendor.reporting_currency_name
      || vendor.reporting_currency_code
      || vendor.reporting_currency;
    vendor.vendor_roles_display = this.formatVendorMasterNamedList(vendor.vendor_roles_detail);
    vendor.restrict_vendor_for_display = this.formatVendorMasterNamedList(vendor.restrict_vendor_for_details);
    vendor.product_sub_category_display = this.formatVendorMasterNamedList(vendor.product_sub_category_details, 'category_name');
    if (!vendor.product_sub_category_display) {
      vendor.product_sub_category_display = this.formatVendorMasterNamedList(vendor.product_sub_category_details);
    }
    vendor.purchasing_org_display = vendor.organization_description
      || this.formatVendorMasterNamedList(vendor.purchasing_org_id, 'organization_description')
      || this.formatVendorMasterNamedList(vendor.purchasing_org_id, 'organization_code')
      || this.formatVendorMasterNamedList(vendor.purchasing_org_id);
    vendor.lob_display = vendor.lob_name || vendor.lob_nick_name
      || this.formatVendorMasterNamedList(vendor.lob_id, 'lob_name');
    vendor.payment_method_display = vendor.payment_method_name
      || this.formatVendorMasterNamedList(vendor.payment_method_id, 'payment_method_name');
    vendor.incoterm_display = vendor.incoterm_name
      || (vendor.incoterm_description
        ? ((vendor.incoterm_name ? vendor.incoterm_name + ' - ' : '') + vendor.incoterm_description)
        : '')
      || vendor.incoterm_code_id
      || '';
    vendor.address_time_zone_display = vendor.address_time_zone_name || vendor.address_time_zone_code || '';
    vendor.prepay_code_display = vendor.prepay_account_name
      || vendor.prepay_account_code
      || vendor.prepay_code
      || '';
    vendor.payment_file_format_display = vendor.payment_file_format_name
      || vendor.payment_file_format
      || vendor.netsuite_payment_file_format
      || '';
    vendor.matching_type_display = vendor.matching_type_name
      || vendor.matching_type
      || '';
    vendor.district_display = vendor.district_name || '';
    vendor.vendor_group_display = vendor.vendor_group_name
      || this.formatVendorMasterNamedList(vendor.vendor_group_id);
    vendor.detailed_payment_terms_display = vendor.detailed_payment_terms
      || vendor.detailed_payment_terms_name
      || '';
    vendor.msme_start_date_display = vendor.msme_start_date
      && vendor.msme_start_date != '0000-00-00' ? vendor.msme_start_date : '';
    vendor.msme_end_date_display = vendor.msme_end_date
      && vendor.msme_end_date != '0000-00-00' ? vendor.msme_end_date : '';
    vendor.fssai_validity_date_display = vendor.fssai_validity_date
      && vendor.fssai_validity_date != '0000-00-00'
      && vendor.fssai_validity_date != 'NaN-NaN-NaN' ? vendor.fssai_validity_date : '';
    vendor.rfi_dating_date_display = vendor.vendor_ranking_date || vendor.rfi_dating_date || '';
    vendor.showApply_tds = vendor.showApply_tds != undefined && vendor.showApply_tds !== null
      ? vendor.showApply_tds
      : vendor.apply_tds;
    vendor.show_Agreement = vendor.show_Agreement != undefined && vendor.show_Agreement !== null
      ? vendor.show_Agreement
      : vendor.is_agreement;
    vendor.routing_no = vendor.routing_no || vendor.bank_routing_no || '';
    vendor.iban_no = vendor.iban_no || vendor.bank_iban_no || '';
    vendor.swift_code = vendor.swift_code || vendor.bank_swift_code || '';
    vendor.relation_type_display = this.getVendorMasterRelationTypeDisplay(vendor.relation_type);
    vendor.document_currency_display = vendor.document_currency_name
      || this.formatVendorMasterNamedList(vendor.document_currency, 'currency_name')
      || vendor.document_currency
      || '';
    vendor.default_document_currency_display = vendor.default_document_currency_name
      || vendor.default_document_currency
      || '';
    vendor.auto_debit_source_display = vendor.auto_debit_source_name
      || vendor.auto_debit_source_label
      || vendor.auto_debit_source_id
      || '';
    vendor.validity_start_date_display = vendor.validity_start_date
      && vendor.validity_start_date != '0000-00-00' ? vendor.validity_start_date : '';
    vendor.tds_validity_date_display = vendor.tds_validity_date
      && vendor.tds_validity_date != '0000-00-00' ? vendor.tds_validity_date : '';
    vendor.is_multiple_vendor_contact_details = vendor.is_multiple_vendor_contact_details != undefined
      ? vendor.is_multiple_vendor_contact_details
      : vendor.add_multiple_vendor_contact_details;
  }

  getVendorMasterRelationTypeDisplay(value: any): string {
    if (!value) {
      return '';
    }
    const relationTypes = [
      { id: 'Director of the Company or any Group Company', name: 'Director of the Company or any Group Company' },
      { id: 'Holding or Subsidiary or any Group Company', name: 'Holding or Subsidiary or any Group Company' },
      { id: 'Leadership Team Member of any of the Group Companies', name: 'Leadership Team Member of any of the Group Companies' },
      { id: 'Relative of Director of the Company or Group Companies', name: 'Relative of Director of the Company or Group Companies' },
      { id: 'Relative of Leadership Team Member of any of the Group Companies', name: 'Relative of Leadership Team Member of any of the Group Companies' },
      { id: 'NA (Not Applicable)', name: 'NA (Not Applicable)' }
    ];
    const matched = relationTypes.filter((item) => { return item.id == value || item.name == value; });
    return matched.length ? matched[0].name : String(value);
  }

  isVendorMasterFlagYes(value: any): boolean {
    return value == '1' || value === 1 || value === true;
  }

  isVendorMasterLocationSiteStatusVisible(): boolean {
    return this.company_setup
      && this.company_setup.enable_active_inactive_status_at_vendor_address_level == '1';
  }

  isVendorMasterBcResponseVisible(): boolean {
    return this.company_setup
      && this.company_setup.enable_integration_to_microsoft_dynamics == '1';
  }

  getVendorMasterContactName(contact: any): string {
    if (!contact) {
      return '';
    }
    return contact.name
      || contact.person_name
      || ((contact.first_name || '') + ' ' + (contact.last_name || '')).trim();
  }

  getVendorMasterAgreementStatus(agreement: any): string {
    if (!agreement) {
      return '';
    }
    const status = agreement.agreement_status;
    if (status == '1' || status === 1 || status === true || status === 'Active') {
      return 'Active';
    }
    if (status == '0' || status === 0 || status === false || status === 'Inactive') {
      return 'Inactive';
    }
    return status ? String(status) : '';
  }

  getVendorMasterEmailList(list: any): string {
    if (!list) {
      return '';
    }
    if (typeof list === 'string') {
      return list;
    }
    if (!list.length) {
      return '';
    }
    return list.map((item) => {
      if (item == null) {
        return '';
      }
      if (typeof item === 'string') {
        return item;
      }
      return item.email || item.person_email || item.name || '';
    }).filter((v) => { return v; }).join(', ');
  }

  private normalizeVendorMasterAddressRow(loc: any): void {
    if (!loc) {
      return;
    }
    loc.gst_display = loc.gst_in_number || loc.gst_no || '';
    loc.salutation_display = loc.salutation_name
      || this.getVendorMasterSalutationDisplay(loc.salutation || loc.Salutation_id);
    loc.district_display = loc.district_name || loc.district || '';
    loc.payment_term_display = loc.payment_term_name || loc.payment_term;
    loc.detailed_payment_terms_display = loc.detailed_payment_terms_name
      || loc.detailed_payment_terms
      || '';
    loc.account_code_display = loc.account_name
      ? (loc.account_name + (loc.account_code ? (' (' + loc.account_code + ')') : ''))
      : (loc.account_id || '');
    loc.cost_center_display = loc.cost_centre_name
      || loc.cost_center_name
      || loc.cost_centre_id_multi
      || loc.cost_centre_id
      || '';
    loc.default_tds_display = loc.default_tds_name || loc.default_tds || '';
    loc.purchasing_org_display = loc.organization_description
      || loc.purchasing_org_name
      || loc.purchasing_org_id
      || '';
    loc.lob_display = loc.lob_name || loc.lob_nick_name || loc.lob_id || '';
    loc.address_time_zone_display = loc.address_time_zone_name || loc.address_time_zone_code || loc.address_time_zone_id || '';
    loc.incoterm_display = loc.incoterm_name
      || (loc.incoterm_description ? (loc.incoterm_name + ' - ' + loc.incoterm_description) : (loc.incoterm_code_id || ''));
    loc.payment_method_display = loc.payment_method_name || loc.payment_method_id || '';
    loc.prepay_code_display = loc.prepay_code || '';
    loc.purchase_group_display = loc.purchase_group_name || loc.purchase_group_master_id || '';
    loc.multiple_email_display = this.getVendorMasterEmailList(loc.address_email);
    loc.person_email_display = this.getVendorMasterEmailList(loc.person_email);
    loc.bc_response_display = loc.tp_ack_message || loc.tp_ack_status || '';
    loc.client_erp_code_display = loc.sap_vendor_supplier || loc.client_erp_code || '';
    loc.withholding_tax_type_display = loc.withholding_tax_type_desc
      || this.formatVendorMasterNamedList(loc.withholding_tax_type_values)
      || '';
    loc.withholding_tax_code_display = loc.withholding_tax_code_desc
      || this.formatVendorMasterNamedList(loc.withholding_tax_code_values)
      || '';
    loc.location_attachment_files = this.normalizeVendorAttachmentList(
      loc.location_attachments ? loc.location_attachments : []
    );
  }

  private normalizeVendorMasterAgreementRow(agr: any): void {
    if (!agr) {
      return;
    }
    agr.status_display = this.getVendorMasterAgreementStatus(agr);
    agr.open_ended_display = this.getVendorMasterYesNo(agr.open_ended_agreement);
    agr.override_direct_inv_display = this.getVendorMasterYesNo(agr.override_direct_inv_limit);
    agr.cost_center_display = agr.mapCostCenterModel
      || agr.mapped_cost_center_name
      || agr.mapped_cost_center_id
      || '';
    agr.vendor_location_display = agr.vendorLocationModel
      || agr.vendor_location_name
      || agr.vendor_location_id
      || '';
    agr.attachment_files = this.normalizeVendorAttachmentList(
      agr.agreement_attachments ? agr.agreement_attachments : []
    );
  }

  getVendorMasterYesNo(value: any): string {
    return value == '1' || value === 1 || value === true ? 'Yes' : 'No';
  }

  getVendorMasterArrayLabel(list: any): string {
    if (!list || !list.length) {
      return '';
    }
    return list.join(', ');
  }

  getVendorMasterEntityType(value: any): string {
    if (value == 'C' || value == 'c') { return 'Company'; }
    if (value == 'I' || value == 'i') { return 'Individual'; }
    if (value == 'P' || value == 'p') { return 'Partnership'; }
    return value ? value : '';
  }

  getVendorMasterMaterialNature(value: any): string {
    if (value == '1' || value === 1) { return 'RM'; }
    if (value == '2' || value === 2) { return 'Non-RM'; }
    return value != undefined && value != null && value !== '' ? String(value) : '';
  }

  getVendorMasterApprovalStatus(status: any): string {
    if (status == 0 || status == '0') { return 'Pending'; }
    if (status == 1 || status == '1') { return 'Approved'; }
    if (status == 2 || status == '2') { return 'Rejected'; }
    if (status == 3 || status == '3') { return 'N/A'; }
    return '';
  }

  getVendorMasterApproverName(row: any): string {
    if (!row) { return ''; }
    const first = row.approval_first_name ? row.approval_first_name : (row.first_name ? row.first_name : '');
    const last = row.approval_last_name ? row.approval_last_name : (row.last_name ? row.last_name : '');
    const code = row.employee_code ? (' (' + row.employee_code + ')') : '';
    return (first + ' ' + last).trim() + code;
  }

  showProductMaster(data: any) {
    this.commonVariableList.isProgressing = true;
    const payload: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      user_id: this._localStorageService.getUserId(),
      product_id: data && (data.product_id || data.id) ? (data.product_id || data.id) : '',
      cost_center_id: data && data.cost_center_id ? data.cost_center_id : '',
    };
    this.webService.commonPostMethod('companies/ajax_getproductbycompany_v2', payload).subscribe(
      resp => {
        if (resp && resp.status) {
          let product: any = resp.product ? resp.product : (resp.response ? resp.response : (resp.data ? resp.data : resp));
          if (product && product.length != undefined && product.length !== null) {
            product = product.length ? product[0] : {};
          }

          // Normalize to booleans for view-only toggles/checkboxes
          const productBoolKeys = ['product_status', 'auto_re_order', 'rcm_applicable', 'gst_not_applicable', 'equalization_levy_applicable', 'warranty', 'installation', 'is_active', 'is_sales_product', 'maintain_rack', 'impact_ageing_report', 'is_for_buy_account', 'is_for_sale_account'];
          productBoolKeys.forEach(k => { product[k] = product[k] == '1' || product[k] === 1 || product[k] === true; });

          // Alias keys to match master template names (price variance)
          product.allowed_price_variance_cvpp_to_po = product.allowed_price_variance_cvpp_to_po != undefined ? product.allowed_price_variance_cvpp_to_po : product.po_cvpp_allowed_price;
          product.allowed_price_variance_po_to_invoice = product.allowed_price_variance_po_to_invoice != undefined ? product.allowed_price_variance_po_to_invoice : product.po_invoice_allowed_price;
          product.allowed_price_variance_cvpp_to_direct_invoice = product.allowed_price_variance_cvpp_to_direct_invoice != undefined ? product.allowed_price_variance_cvpp_to_direct_invoice : product.cvpp_inv_allowed_price;

          // Normalize unit_types rows for checkbox UI
          product.unit_types = product.unit_types ? product.unit_types : [];
          if (product.unit_types && product.unit_types.length) {
            product.unit_types = product.unit_types.map(function (u) {
              u.searcUnitType = u.searcUnitType ? u.searcUnitType : '';
              u.is_default_buy_uae = u.is_default_buy_uae == '1' || u.is_default_buy_uae === 1 || u.is_default_buy_uae === true;
              u.is_default_sales_uae = u.is_default_sales_uae == '1' || u.is_default_sales_uae === 1 || u.is_default_sales_uae === true;
              u.is_default = u.is_default == '1' || u.is_default === 1 || u.is_default === true;
              return u;
            });
          }

          // Drive master-like UI variables
          this.visible = this.visibleProductMaster;
          this.isViewMode = true;
          this.productData = [product];

          // Populate minimal lists so disabled md2-selects show selected labels
          this.UnitTypeList = product.unit ? [{ id: product.unit, unit_type: product.unit_type_name ? product.unit_type_name : product.unit }] : [];
          this.hsncodelist = product.hsn_id ? [{ id: product.hsn_id, name: product.hsn_code }] : (product.hsnid ? [{ id: product.hsnid, name: product.hsn_code }] : []);
          this.typeList = product.product_type ? [{ name: product.product_type }] : [];
          this.typeList2 = product.product_type2_id ? [{ id: product.product_type2_id, type_name: product.product_type2_name ? product.product_type2_name : product.product_type2_id }] : [];
          this.productCategory = product.category ? [{ id: product.category, name: product.category_name ? product.category_name : product.category }] : [];
          this.productSubCategory = product.subcategory ? [{ id: product.subcategory, name: product.subcategory_name ? product.subcategory_name : product.subcategory }] : [];
          this.accountCodeList = product.account_id ? [{ id: product.account_id, name: product.account_name ? product.account_name : (product.account_code ? product.account_code : product.account_id) }] : (product.account_code ? [{ id: product.account_code, name: product.account_name ? product.account_name : product.account_code }] : []);
          this.qcList = product.qc_process ? [{ id: product.qc_process, name: product.qc_process }] : [];
          this.tdsList = product.tds_id ? [{ id: product.tds_id, section_name: product.section_name ? product.section_name : product.tds_id }] : [];
          const approvalName = product.approval_name || (product.approved_by_first_name || product.approved_by_last_name
            ? [product.approved_by_first_name, product.approved_by_last_name].filter(Boolean).join(' ').trim() : '');
          this.approvalList = approvalName ? [{ id: product.approval_id || approvalName, name: approvalName }] : [];

          this.commonVariableList.tableDetails = {
            id: 'productmaster',
            is_setup: true,
            setup: this.company_setup,
            data: { items: [product], is_no_tds_deduction: "1" }
          };
          this.commonVariableList.attachments = resp.attachments ? resp.attachments : (product && product.attachments ? product.attachments : []);

          // Build master-like savedFiles array for in-form attachment UI
          const atts: any[] = this.commonVariableList.attachments && this.commonVariableList.attachments.length ? this.commonVariableList.attachments : [];
          this.savedFiles = atts.map(a => {
            const filename = a.filename ? a.filename : (a.file_name ? a.file_name : (a.name ? a.name : ''));
            const display = a.display ? a.display : (a.attachment ? a.attachment : (a.url ? a.url : ''));
            const ext = this.webService.getFileExtension(display ? display : filename);
            return {
              filename: filename,
              display: display,
              iconclass: this.webService.getFileIcon(ext ? ext : ''),
            };
          });
        } else {
          this.toasterService.pop('error', 'Error', resp && resp.message ? resp.message : 'No data found');
        }
        this.commonVariableList.isProgressing = false;
      },
      error => {
        this.commonVariableList.isProgressing = false;
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
      }
    );
  }

  // Stubs used by master Product UI template (view-only)
  is_column_mandatory(key: string, is_child: boolean): boolean { return false; }
  is_column_disabled(key: string, is_child: boolean): boolean { return false; }
  is_Valid_Action(name: string): boolean { return false; }
  setUnitType(v: any) { }
  getProductNature(v: any) { }
  getSubcategory(v: any, idx: any) { }
  checkIsCapex(idx: any, key: any) { }
  getCategoryCodeOnChange(idx: any, v: any, key: any, mode: any) { }
  validateProductType(v: any, idx: any) { }
  selected(e: any) { }
  getImpactValue(v: any, idx: any) { }
  rcm(v: any) { }
  rcmndgst(v: any) { }
  BuyAccountInfo() { }
  SaleAccountInfo() { }
  salesProductChange(idx: any) { }
  isAlreadyDefaultUOM(idx: any): boolean { return false; }
  setBuyUOE(v: any, i: any) { }
  setSaleUOE(v: any, i: any) { }
  setDefaultUOE(v: any, i: any) { }
  addArray(idx: any) { }
  importUnitype(u: any) { }
  deleteArray(di: any, i: any) { }
  changeListener(e: any) { }
  removeImage(i: any) { }
  showToolTip(v: any) { }
  getData(v: any) { return ''; }
  showProductpup() { }
  checktaxrate(v: any, key: any) { }
  /** Display text for Product Master view-only popup (no md2-select); uses pre-filled lists from API */
  getProductMasterUnitDisplay(): string { return (this.UnitTypeList && this.UnitTypeList[0]) ? (this.UnitTypeList[0].unit_type || '') : ''; }
  getProductMasterCategoryDisplay(): string { return (this.productCategory && this.productCategory[0]) ? (this.productCategory[0].name || '') : ''; }
  getProductMasterSubCategoryDisplay(): string { return (this.productSubCategory && this.productSubCategory[0]) ? (this.productSubCategory[0].name || '') : ''; }
  getProductMasterHsnDisplay(): string { return (this.hsncodelist && this.hsncodelist[0]) ? (this.hsncodelist[0].name || '') : ''; }
  getProductMasterType2Display(): string { return (this.typeList2 && this.typeList2[0]) ? (this.typeList2[0].type_name || '') : ''; }
  getProductMasterTdsDisplay(): string { return (this.tdsList && this.tdsList[0]) ? (this.tdsList[0].section_name || '') : ''; }
  getProductMasterApprovalDisplay(): string {
    const p = this.productData && this.productData[0];
    if (p && p.approved_by_first_name) {
      const fn = String(p.approved_by_first_name).replace(/\s+/g, '').toUpperCase();
      return p.employee_code ? `${fn} (${String(p.employee_code).trim()})` : fn;
    }
    return (this.approvalList && this.approvalList[0]) ? (this.approvalList[0].name || '') : '';
  }
  getId(id: any, action: string, data: any) {
    this.sendAction.emit({
      "id": id,
      "action": action,
      "data": data,
    });
  }
  hideModal() {
    this.modalDetails.is_view = false;
    localStorage.setItem('dataList', '');
    document.getElementById('body').style.overflow = 'auto';
  }
  showPr(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "pr_no": data.pr_no }
    let api_url='pr/ajax_getsingleprdatabypr';
    let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
    let isdraft = data.is_draft
    if(isdraft=='1')
    {
      payload.is_draft=isdraft;
      api_url='/Pr/ajax_getsingledraftprdata'
    }
    else{
      api_url='pr/ajax_getsingleprdatabypr'
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(api_url, data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            if (response.pr_items) {
              let sl_no: number = 1;
              for (let j of response.pr_items) {
                j.sl_no = sl_no;
                j.product_catalog_id = j.product_catalog_id ? j.product_catalog_id : j.product.product_catalog_id

                j.product_name = j.product.product_name;
                j.productcode = j.product.productcode;
                j.is_temp_prod = j.product.is_temp_prod ? j.product.is_temp_prod : '0';
                j.product_name = j.product_name + (j.is_temp_prod=='1' ? '' : "(" + j.productcode + ")");
                j.product_type = j.product.product_type ? j.product.product_type : '';
                sl_no++;
              }
            }
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }
            if(Array.isArray(response.need_info))
            {
              response.need_info={"user":{}};
            }
            response.is_need_info=Array.isArray(response.info_history)?response.info_history.length>0?true:false:false;
            response.is_need_info= response.is_need_info;
            response.info_history= response.info_history?response.info_history:[]

            if(response.info_history)
            {
              for(let i of response.info_history)
              {

                i.approval_first_name=i.requested_by_first_name?i.requested_by_first_name:''
                i.approval_last_name=i.requested_by_last_name?i.requested_by_last_name:'';
                i.employee_code=i.requested_by_employee_code?i.requested_by_employee_code:'';

                i.info_first_name=i.requestby.first_name?i.requestby.first_name:'';
                i.info_last_name=i.requestby.last_name?i.requestby.last_name:'';
                i.info_employee_code=i.requestby.employee_code?i.requestby.employee_code:'';

              }
            }
            response.requested_by = response.user.first_name + " " + response.user.last_name + "(" + response.user.employee_code + ")"

            response.location = response.location.location ? response.location.location : ''
            response = data.response ? data.response : {};

            response.dimension_type_name = response.dimension_type_name ? response.dimension_type_name : ''
            response.boq_dimension_type_name = response.boq_dimension_type_name ? response.boq_dimension_type_name : ''


            response.dimension_name = response.dimension_name ? response.dimension_name : ''
            if (response.dimension_type_name != '') {
              response.dimension_name = response.dimension_name + "(" + response.dimension_type_name + ")";
            }

            response.boq = response.boq ? response.boq : '';
            response.is_boq = response.is_boq == '1' ? true : false;
            response.boq_quantity = response.boq_quantity ? response.boq_quantity : '';
            if (response.boq_dimension_type_name != '') {
              response.boq_name = response.boq_name + "(" + response.boq_dimension_type_name + ")";
            }
           response.customer_detail='';
            if(response.customer_first_name!='' &&response.customer_first_name!=undefined)
            {
            response.customer_detail=response.customer_first_name+" "+response.customer_last_name+" ("+response.customer_code+")";
            }
            if(response.customer_address!='' && response.customer_address!=null)
            {
             response.customer_detail=response.customer_address;
            }
            response.project_name=response.project_name?response.project_name:'';
            response.project_code=response.project_code?response.project_code:'';
            response.project_detail='';
             if(response.project_name!='' &&response.project_name!=undefined)
             {
              response.project_detail=response.project_name+" ("+response.project_code+")";
             }
            response.task_name=response.task_name?response.task_name:'';
            response.task_code=response.task_code?response.task_code:'';
            response.task_detail='';
             if(response.task_name!='' &&response.task_name!=undefined)
             {
              response.task_detail=response.task_name+" ("+response.task_code+")";
             }

            response.sales_order_no = response.sales_order_no ? response.sales_order_no : '';
            response.pr_approvals = []
            response.pr_approvals = response.approvals ? response.approvals : [];
            // response.pr_attachments = [];
            // response.pr_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []
            response.ship_dept_name=response.ship_dept_name?response.ship_dept_name:'';
            response.ship_dept_code=response.ship_dept_code?response.ship_dept_code:'';
            response.ship_primary_loc_name=response.ship_primary_loc_name?response.ship_primary_loc_name:'';
            response.ship_primary_loc_code=response.ship_primary_loc_code?response.ship_primary_loc_code:'';
            response.ship_lob_name=response.ship_lob_name?response.ship_lob_name:'';
            response.ship_lob_code=response.ship_lob_code?response.ship_lob_code:'';

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "prreport";
          response.data = response;

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIr(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "ir_no": data.ir_no }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('Ir/ajax_getsingleprdatabyir', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response ? data.response : {};
            this.irFields.prepareIrReportDataForDisplay(response);
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }

            response.requested_by = response.user.first_name + " " + response.user.last_name + "(" + response.user.employee_code + ")"

            response.location = response.location.location ? response.location.location : ''
            response = data.response ? data.response : {};

            response.dimension_type_name = response.dimension_type_name ? response.dimension_type_name : ''
            response.boq_dimension_type_name = response.boq_dimension_type_name ? response.boq_dimension_type_name : ''


            response.dimension_name = response.dimension_name ? response.dimension_name : ''
            if (response.dimension_type_name != '') {
              response.dimension_name = response.dimension_name + "(" + response.dimension_type_name + ")";
            }

            response.boq = response.boq ? response.boq : '';
            response.is_boq = response.is_boq == '1' ? true : false;
            response.boq_quantity = response.boq_quantity ? response.boq_quantity : '';
            if (response.boq_dimension_type_name != '') {
              response.boq_name = response.boq_name + "(" + response.boq_dimension_type_name + ")";
            }
            response.pr_approvals = []
            response.pr_approvals = response.approvals ? response.approvals : [];
            response.pr_attachments = [];
            response.pr_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "irreport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raiseir');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIRHistory(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "ir_id": data.ir_id }
    this.commonVariableList.isProgressing = true;
    this.commonVariableList.historyList=[];
    this.webService.commonPostMethod('Ir/ir_history', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            let temp:any=[];
            temp = data.response ? data.response :[];
            if(temp)
            {
              for(let m of temp)
              {
            this.irFields.prepareIrReportDataForDisplay(m);
            if (m.approvals) {
              for (let i of m.approvals) {
                i.approval_first_name = i.user.first_name
                i.approval_last_name = i.user.last_name
                i.employee_code = i.user.employee_code;

              }
            }

            m.requested_by = m.user.first_name + " " + m.user.last_name + "(" + m.user.employee_code + ")"

            m.location = m.location.location ? m.location.location : ''
            m = m ? m : {};

            m.dimension_type_name = m.dimension_type_name ? m.dimension_type_name : ''
            m.boq_dimension_type_name = m.boq_dimension_type_name ? m.boq_dimension_type_name : ''


            m.dimension_name = m.dimension_name ? m.dimension_name : ''
            if (m.dimension_type_name != '') {
              m.dimension_name = m.dimension_name + "(" + m.dimension_type_name + ")";
            }

            m.boq = m.boq ? m.boq : '';
            m.is_boq = m.is_boq == '1' ? true : false;
            m.boq_quantity = m.boq_quantity ? m.boq_quantity : '';
            if (m.boq_dimension_type_name != '') {
              m.boq_name = m.boq_name + "(" + m.boq_dimension_type_name + ")";
            }
            m.pr_approvals = []
            m.pr_approvals = m.approvals ? m.approvals : [];
            m.pr_attachments = [];
            m.pr_attachments = m.attachments ? m.attachments : []
            m.attachment = [];
            m.attachment = this.webService.makeAttachment(m.attachments) ? this.webService.makeAttachment(m.attachments) : []
            m.id = "ir_history_report";
            m.data = m;
            this.commonVariableList.dataList.push(m)
      m.beforedivList = m.beforedivList ? m.beforedivList : []
      m.afterdivList = m.afterdivList ? m.afterdivList : []


    m.afterDivDetails = {};
    m.afterDivDetails = m;
    m.beforeDivDetails = {};
    m.beforeDivDetails = m;
    m.tableDetails = {};
    m.tableDetails = m;
    m.approvalDetails = {};
    m.approvalDetails = m;
    m.allocableCostDetails = {};
    m.allocableCostDetails = m;
    m.allocableCostDetails.lines = m.allocable_cost_items || [];
    m.allocableCostDetails.viewContext = (m.tableDetails && m.tableDetails.data) ? m.tableDetails.data : (m || {});
    m.allocableCostDetails.caption = 'Additional Cost Line items (Not Part of Vendor PO)';
    m.allocableCostDetails.is_setup = true;
    m.allocableCostDetails.setup = this.comanySetup.getData();
    m.allocableCostDetails.is_view = this.isAllocableCostTableVisibleForHistory(m);
    m.attachments = [];
    m.attachments = m.attachment ? m.attachment : [];
            this.commonVariableList.historyList.push(m);
          }
        }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
            response.id = "ir_history_report";
            response.data = response;
            this.commonVariableList.historyList.push(response);
          }
          // response.id = "ir_history_report";
          // response.data = response;
          this.modalDetails.name="IR History"
          this.modalDetails.is_view = true;
          this.commonVariableList.isProgressing = false;
          // this.makeFinalData(response);

        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showPo(data) {
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };

    let payload: any = { "po_no": data.po_no ,'is_modified':data.is_modified?data.is_modified:'0',
  type:'my_po'
  }
  let api_url='po/ajax_get_single_podetails';
  let url:any='/'+window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
  if(data.is_draft=='1')
  {
    payload.is_draft=data.is_draft;
    api_url='po/get_single_draft_po'
  }
  if(url!='/my-orders')
  {
  delete payload['type'];

  }
  console.log(url);
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(api_url, data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.items) {
              for (let j of data.response.items) {



                j.amend_po_status=j.is_amend=='1'?'Closed':'';
                j.amend_po_qty=j.is_amend=='1'?j.close_po_qty:'';
                j.amend_date=j.amend_date?j.amend_date:'';
                j.amend_added_by=j.amend_added_by?j.amend_added_by:'';

                // Prefer showing HSN with IGST details (if available), else show plain HSN code.
                // Generic table column mapping uses "hsn_code", so normalize it for display.
                let hsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let hsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = hsnCodeIgst ? hsnCodeIgst : hsnCode;

                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.ship_location_nickname_9_digit = data.response.ship_to_location_name.location_nickname_9_digit;
                j.ship_location_code_9_digit = data.response.ship_to_location_name.location_code_9_digit;

                j.ship_to_location = j.ship_location_nickname_9_digit ? j.ship_location_nickname_9_digit : j.ship_to_location;
                j.ship_to_location = (this.company_setup.display_gst_number_in_bill_to_and_ship_to_locations == '1' && data.response.ship_to_location_name && data.response.ship_to_location_name.location) ? data.response.ship_to_location_name.location : (j.ship_location_nickname_9_digit + "(" + j.ship_location_code_9_digit + ")");

                j.total_duration = j.total_duration ? j.total_duration : '';
                j.is_logistic = j.is_logistic == '1' ? true : false;

                j.hsn_cess=j.hsn_cess?j.hsn_cess:''
                j.hsn_other_tax=j.hsn_other_tax?j.hsn_other_tax:''
                j.hsn_ugst=j.hsn_ugst?j.hsn_ugst:''
                j.hsn_cgst=j.hsn_cgst?j.hsn_cgst:''
                j.hsn_sgst=j.hsn_sgst?j.hsn_sgst:''
                j.hsn_igst=j.hsn_igst?j.hsn_igst:''
                j.info_employee_code = j.info_employee_code ? j.info_employee_code :''
                j.info_first_name = j.info_first_name ? j.info_first_name :''
                j.info_last_name = j.info_last_name ? j.info_last_name :''
                j.is_raiser = j.is_raiser ? j.is_raiser :''
                if(this.company_setup.gst_fields_not_shown_when_value_is_zero == '1'){
                  j.CgstVisible = data.response.items ? data.response.items.some((d)=>{return d.cgst>0}): false;
                  j.SgstVisible = data.response.items ? data.response.items.some((d)=>{return d.sgst>0}): false;
                  j.IgstVisible = data.response.items ? data.response.items.some((d)=>{return d.igst>0}): false;
                  j.UgstVisible = data.response.items ? data.response.items.some((d)=>{return d.ugst>0}): false;
                  j.CessVisible = data.response.items ? data.response.items.some((d)=>{return d.cess>0}): false;
                  j.OthertaxVisible = data.response.items ? data.response.items.some((d)=>{return d.other_tax>0}): false;
                  j.DiscountAmount = data.response.items ?  data.response.items.some((d)=>{return d.discount_amount>0}): false;
                } else {
                  j.CgstVisible = true;
                  j.SgstVisible = true;
                  j.IgstVisible = true;
                  j.UgstVisible = true;
                  j.CessVisible = true;
                  j.OthertaxVisible = true;
                  j.DiscountAmount = true;
                }
              }
            }

            response = data.response ? data.response : {};
            response.bill_location_nickname_9_digit = data.response.bill_to_location_name.location_nickname_9_digit;
            response.bill_location_code_9_digit = data.response.bill_to_location_name.location_code_9_digit;
            response.is_boq = data.response.is_boq == '1' ? true : false;
            response.is_different_document_currency = data.response.is_different_document_currency == '1' ? true : false;
            // Get document_currency_code from multiple possible sources
            response.document_currency_code = data.response.document_currency_code || data.response.currency_code || (data.response.currency && data.response.currency.code) || '';

            response.is_draft = api_url=='po/get_single_draft_po'?'1':'0'
            response.po_items = [];
            response.po_items = response.items ? response.items : []
            response.po_approvals = []
            response.po_approvals = response.approvals ? response.approvals : [];
            response.po_attachments = [];
            response.po_attachments = response.attachments ? response.attachments : []
            response.attachment = [];
            response.po_additional_attachment =[]
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : [];
            response.po_additional_attachment = this.webService.makeAttachment(response.po_additional_attachments) ? this.webService.makeAttachment(response.po_additional_attachments) : [];
            response.po_additional_attachments_title= response.po_additional_attachments ? 'PO Additional Attachment':''

            response.contractualPoAttachments = this.webService.makeAttachment(response.contractualPoAttachments) ? this.webService.makeAttachment(response.contractualPoAttachments) : [];
            response.requested_by_employee_code = response.requested_by_employeecode ? response.requested_by_employeecode : '';

            // Handle allocable cost items
            this.commonVariableList.is_allocable_cost = data.response.is_allocable_cost == "1" ? true : false;
            this.commonVariableList.allocableCostLines = data.response.allocable_cost_items ? data.response.allocable_cost_items : [];
            // Store document_currency_code for easy access in template
            this.commonVariableList.document_currency_code = response.document_currency_code || '';
            if (this.commonVariableList.allocableCostLines && this.commonVariableList.allocableCostLines.length > 0) {
              // Sort allocableCostLines to maintain order
              this.commonVariableList.allocableCostLines.sort((a, b) => {
                const idA = a.allocable_cost_item_id || a.id;
                const idB = b.allocable_cost_item_id || b.id;
                if (idA && idB) {
                  return idA - idB;
                }
                return 0; // Preserve original order if no ID is present
              });
              for (let costLine of this.commonVariableList.allocableCostLines) {
                costLine.planned_amount_in_po_currency = costLine.planned_amount_in_po_currency || '0.00';
                costLine.planned_amount_in_base_currency = costLine.planned_amount_in_base_currency || '0.00';
              }
            }

            if(this.modalDetails.data && this.modalDetails.data.type == 'fulfilled_po'){
              response.fulfilled_po_upload_invoice = [];
              response.fulfilled_po_upload_invoice = this.webService.makeAttachment(response.fulfilled_po_upload_file) ? this.webService.makeAttachment(response.fulfilled_po_upload_file) : [];
              response.fulfilled_po_upload_invoice_title = response.fulfilled_po_upload_file && response.fulfilled_po_upload_file.length > 0 ? 'Upload Invoice' : '';
              
              response.fulfilled_po_vendor_attachment = [];
              response.fulfilled_po_vendor_attachment = this.webService.makeAttachment(response.fulfilled_po_upload_invoice_attachment) ? this.webService.makeAttachment(response.fulfilled_po_upload_invoice_attachment) : [];
              response.fulfilled_po_vendor_attachment_title = response.fulfilled_po_upload_invoice_attachment && response.fulfilled_po_upload_invoice_attachment.length > 0 ? 'Vendor Attachment' : '';
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };
          }

          response.id = "poreport";
          response.data = response;
          if(this.modalDetails.data && this.modalDetails.data.type == 'fulfilled_po'){
            this.modalDetails.name = this.modalDetails.name ? this.modalDetails.name : 'Vendor Fulfilled PO';
          } else {
            this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/raise-po');
          }
          this.makeFinalData(response);



        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [], "contractualPoAttachments": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showIrn(data) {
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    const requestData: any = data ? data : {};
    

    let payload: any = { "irn_cs_id": data.cs_id, "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('irn/ajax_get_single_irndetails', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.irn_items) {
              for (let j of data.response.irn_items) {
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present, else plain HSN (same as PO / invoice popup).
                let irnHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let irnHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = irnHsnCodeIgst ? irnHsnCodeIgst : irnHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.is_damaged = j.is_damaged == '1' ? true : false;
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.merge_barcode=j.merge_barcode=='1'?true:false;
                j.total_grn_value_po_price = j.po_total_price ? j.po_total_price : '';

              }
            }
            if(data.response.irn_other_info)
            {
              for(let i of data.response.irn_other_info)
              {
                i.first_name=i.first_name?i.first_name:''
                i.last_name=i.last_name?i.last_name:''
                i.adhoc_employee_id=i.first_name+" "+i.last_name;
                if(i.employee_code!=undefined && i.employee_code!=null)
                {
                  i.adhoc_employee_id=i.adhoc_employee_id+" ("+i.employee_code+")";
                }
              }
            }
            response = data.response ? data.response : {};
            response.acceptedList = response.acceptedList ? response.acceptedList : [];
            response.rejectedList = response.rejectedList ? response.rejectedList : [];
            response.hide_free_qty_if_zero = requestData.hide_free_qty_if_zero ? requestData.hide_free_qty_if_zero : '0';

            response.bill_to_location = response.bill_to_location_name
            response.ship_to_location = response.ship_to_location_name

            response.requested_by_first_name = response.added_by_first_name;
            response.requested_by_last_name = response.added_by_last_name;
            response.requested_by_employee_code = response.added_by_employee_code;
            response.approval_status=response.approval_status;
            if(response.approvals)
            {
              for(let i of response.approvals)
              {
                i.approval_first_name=i.approval_first_name?i.approval_first_name:i.first_name;
                i.approval_last_name=i.approval_last_name?i.approval_last_name:i.last_name
              }
            }
            response.approvals = response.approvals ? response.approvals : [];

            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

            response.extra_attachment_1 = [];
            response.extra_attachment_1 = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []
            response.extra_attachment_qc = [];
            response.extra_attachment_qc = this.webService.makeAttachment(response.irn_attachments) ? this.webService.makeAttachment(response.irn_attachments) : []
            response.extra_attachment_1_title='Invoice Files'
            response.attachment_title='IRN Files'
            response.attachment_title_qc='IRN Files'

            response.multi_attachments = response.multi_attachments ? response.multi_attachments : [];
            response.invoice_attachments = response.invoice_attachments ? response.invoice_attachments : [];
            response.attachments = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []



            for(let i of response.multi_attachments) {
              i.attachments = this.webService.makeAttachment(i.attachments) ? this.webService.makeAttachment(i.attachments) : []
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "irnreport";
          response.data = response;
          // this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/new-irn');
          this.modalDetails.name = this.irn_to_grn +' '+'Data';

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showGrn(data) {

    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    const requestData: any = data ? data : {};

    // let payload: any = { "grn_cs_id": data.cs_id ? data.cs_id : '' }
    //chanukya chainged according to saurabh req
    let Id: any = "";
    data.has_approved_once=data.has_approved_once?data.has_approved_once:''
    if (data.cs_id) {
      Id = data.cs_id
    }
    if (data.cs_id.cs_id) {
      Id = data.cs_id.cs_id
    }
    let url:any='';
    if(data.is_summary=='1')
    {
      url="Grn/ajax_get_grn_detailsbyid";
    }
    else
    {
url="Grn/ajax_get_grn_byid";
    }

    let payload: any = {
      // "grn_cs_id":data.cs_id.cs_id,
      "grn_cs_id": Id,
      "grn_id": data.grn_id ? data.grn_id : '',
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      // "is_unapproved_grn" : this.company_setup.has_multi_grn_approval ? this.company_setup.has_multi_grn_approval : "0",
      "has_approved_once":data.has_approved_once?data.has_approved_once:''
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.grn_items) {
              for (let j of data.response.grn_items) {
                let allocated_arr:any=[];
                let allocated_rack_code='';
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.product_description=j.product_description?j.product_description:'';

                j.merge_barcode=j.merge_barcode=='1'?true:false;
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present, else plain HSN (same as PO / invoice popup).
                let grnHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let grnHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = grnHsnCodeIgst ? grnHsnCodeIgst : grnHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.is_closed = j.is_closed == '1' ? true : false;
                j.send_damage_mail = j.send_damage_mail == '1' ? true : false;
                j.merge_barcode=j.merge_barcode?j.merge_barcode:'0';
                j.merge_barcode=j.merge_barcode=='1'?true:false;
                if(j.allocated_rack && j.allocated_rack.length>0)
                {
                  for(let m of j.allocated_rack)
                  {
                   m.allocated_rack_code = m.allocated_rack_no + " (" + m.allocated_qty + ")";
                   allocated_arr.push(m.allocated_rack_code)
                  }
                  allocated_rack_code=allocated_arr.join(',');
                }
                j.allocated_rack_code=allocated_rack_code?allocated_rack_code:''
                j.total_grn_value_po_price = j.po_total_price ? j.po_total_price : '';
              }
            }
            if(data.response.grn_other_info)
            {
              for(let i of data.response.grn_other_info)
              {
                i.first_name=i.first_name?i.first_name:''
                i.last_name=i.last_name?i.last_name:''
                i.adhoc_employee_id=i.first_name+" "+i.last_name;
                if(i.employee_code!=undefined && i.employee_code!=null)
                {
                  i.adhoc_employee_id=i.adhoc_employee_id+" ("+i.employee_code+")";
                }
              }
            }
            response = data.response ? data.response : {};
            response.hide_free_qty_if_zero = requestData.hide_free_qty_if_zero ? requestData.hide_free_qty_if_zero : '0';
            response.bill_location_nickname_9_digit = response.bill_name?response.bill_name:response.bill_location_nickname_9_digit;
            response.ship_location_nickname_9_digit = response.ship_name;

            

            response.acceptedList = response.acceptedList ? response.acceptedList : [];
            response.rejectedList = response.rejectedList ? response.rejectedList : [];
            response.grn_acceptedList = response.grn_acceptedList ? response.grn_acceptedList : [];
            response.grn_rejectedList = response.grn_rejectedList ? response.grn_rejectedList : [];
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : ''
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.approvals = response.approvals ? response.approvals : [];

            response.attachment = [];
            response.attachment = this.webService.makeAttachment(response.attachments) ? this.webService.makeAttachment(response.attachments) : []

            response.extra_attachment_1 = [];
            response.extra_attachment_1 = this.webService.makeAttachment(response.invoice_attachments) ? this.webService.makeAttachment(response.invoice_attachments) : []

            response.extra_attachment_qc = [];
            response.extra_attachment_qc = this.webService.makeAttachment(response.irn_attachments) ? this.webService.makeAttachment(response.irn_attachments) : []

            response.extra_attachment_1_title='Invoice Files'
            response.attachment_title='QC Files'
            response.attachment_title_qc='IRN Files'
                          response.multi_attachments = response.multi_attachments ? response.multi_attachments : [];
            for(let i of response.multi_attachments) {
              i.attachments = this.webService.makeAttachment(i.attachments) ? this.webService.makeAttachment(i.attachments) : []
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "grnreport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-grn');
           this.modalDetails.name = this.grn_to_qc + ' ' + 'Data';

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showGatePass(data) {
    let response: any = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    const gatePassId = data.gate_pass_id || data.id || '';
    const payload: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      gate_pass_id: gatePassId,
      user_id: this._localStorageService.getUserId() || '0'
    };
    if (data.is_edit_approval_page != null && data.is_edit_approval_page !== '') {
      payload.is_edit_approval_page = data.is_edit_approval_page.toString();
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('Gate_pass/ajax_get_gate_pass_by_id', payload).subscribe(
      data => {
        if (data.status) {
          response = data.response ? data.response : {};
          if (response.items) {
            let sl_no: number = 1;
            for (let j of response.items) {
              j.sl_no = sl_no;
              j.product_description = j.description ? j.description : (j.product_description ? j.product_description : '');
              if (j.productcode && j.product_name && j.product_name.indexOf('(') < 0) {
                j.product_name = j.product_name + ' (' + j.productcode + ')';
              }
              j.unit_type_name = j.unit_type_name ? j.unit_type_name : (j.unit_type ? j.unit_type : '');
              sl_no++;
            }
          }
          response.gate_pass_items = response.items ? response.items : [];
          if (response.approvals) {
            for (let i of response.approvals) {
              // Minimal mapping for generic-approvals
              i.employee_level = i.employee_level ? i.employee_level : (i.approval_level ? i.approval_level : '');
              i.date_updated = i.date_updated ? i.date_updated : (i.approved_date ? i.approved_date : '');
              this.mapGatePassApproverName(i);
            }
          }
          const attachmentLists = [
            response.attachments,
            response.invoice_attachments,
            response.scan_attachments,
            response.questionnaire_attachments
          ];
          let allAttachments: any[] = [];
          for (const list of attachmentLists) {
            if (list && list.length) {
              allAttachments = allAttachments.concat(list);
            }
          }
          response.attachment = this.webService.makeAttachment(allAttachments) ? this.webService.makeAttachment(allAttachments) : [];
          response.attachment_title = response.attachment_title ? response.attachment_title : 'Attachments';

          // Gate Pass Questionnaire attachments (same pattern as IRN multi_attachments used by generic-grand-table)
          response.multi_attachments = response.questionnaire_attachments ? response.questionnaire_attachments : [];
          for (let i of response.multi_attachments) {
            const list = i.all_attachment ? i.all_attachment : (i.attachments ? i.attachments : []);
            i.attachments = this.webService.makeAttachment(list) ? this.webService.makeAttachment(list) : [];
            i.unique_id = i.unique_id ? i.unique_id : '';
            i.note_name = i.note_name ? i.note_name : '';
            i.remarks = i.remarks ? i.remarks : '';
          }
        } else {
          this.toasterService.pop('error', 'Error', data.message);
          response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
        }
        response.id = 'gatepassreport';
        response.data = response;
        this.makeFinalData(response);
      },
      error => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
        response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
        this.commonVariableList.isProgressing = false;
      }
    );
  }

  // Gate Pass only: map `approver_name` into generic-approvals fields
  mapGatePassApproverName(row: any) {
    if (!row) {
      return;
    }
    const name = row.approver_name != null ? row.approver_name.toString() : '';
    if (!name) {
      return;
    }
    const parts = name.split('(');
    const namePart = parts[0] ? parts[0].trim() : '';
    const codePart = parts[1] ? parts[1].replace(')', '').trim() : '';
    if (namePart) {
      const words = namePart.split(' ').filter((w: string) => w.trim() !== '');
      row.approval_first_name = words.length ? words[0] : namePart;
      row.approval_last_name = words.length > 1 ? words.slice(1).join(' ') : '';
    }
    row.employee_code = codePart;
  }

  showGatePassHistory(rowData: any) {
    // Use gatePassHistoryProgressing for loader in this view (keep generic modal visible)
    this.commonVariableList.isProgressing = false;
    this.gatePassHistoryList = [];
    this.gatePassHistoryObj = {};
    this.gatePassHistoryProgressing = true;
    this.gatePassHistoryDivDetails.is_view = false;
    this.gatePassHistoryApprovalDetails.is_view = false;
    this.gatePassHistoryTableDetails.is_view = false;

    const gatePassId = rowData && (rowData.gate_pass_id || rowData.id) ? (rowData.gate_pass_id || rowData.id) : '';
    const req: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      gate_pass_id: gatePassId
    };
    this.webService.commonPostMethod('Gate_pass/ajax_gate_pass_history', req).subscribe(
      data => {
        const list = data && data.response ? data.response : [];
        // Some APIs return {count, response: []} without {status}
        if (data && (data.status === true || data.status === undefined)) {
          this.gatePassHistoryList = list ? list : [];
          if (this.gatePassHistoryList && this.gatePassHistoryList.length) {
            for (const i of this.gatePassHistoryList) {
              i.is_active = false;
              i.history_type = i.record_action ? i.record_action : (i.meta_key ? i.meta_key : '');
              i.added_by = i.added_by_name ? i.added_by_name : (i.added_by ? i.added_by : '');
            }
            // Match PO/GRN history: order by id (not date_added — same timestamp can swap Update/Approve)
            this.gatePassHistoryList = this.gatePassHistoryList ? this.gatePassHistoryList.sort((a, b) => a.id - b.id) : [];
            const lastIndex = this.gatePassHistoryList.length - 1;
            this.getGatePassHistoryAccordingToId(gatePassId, this.gatePassHistoryList[lastIndex], lastIndex);
          } else {
            this.gatePassHistoryProgressing = false;
            this.commonVariableList.isProgressing = false;
          }
        } else {
          this.toasterService.pop('error', 'Error', data.message);
          this.gatePassHistoryProgressing = false;
          this.commonVariableList.isProgressing = false;
        }
      },
      () => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
        this.gatePassHistoryProgressing = false;
        this.commonVariableList.isProgressing = false;
      }
    );
  }

  getGatePassHistoryAccordingToId(gatePassId: any, historyData: any, index: number) {
    this.gatePassHistoryObj = {};
    historyData = historyData ? historyData : {};
    this.gatePassHistoryProgressing = true;
    this.gatePassHistoryDivDetails.is_view = false;
    this.gatePassHistoryApprovalDetails.is_view = false;
    this.gatePassHistoryTableDetails.is_view = false;

    if (this.gatePassHistoryList && this.gatePassHistoryList.length) {
      this.gatePassHistoryList[index].is_active = !this.gatePassHistoryList[index].is_active;
      let row: number = 0;
      for (let i of this.gatePassHistoryList) {
        if (row !== index) {
          i.is_active = false;
        }
        row++;
      }
    }

    const historyId = historyData && historyData.id ? historyData.id : '';
    const req: any = {
      company_id: this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
      gate_pass_id: gatePassId,
      history_id: historyId
    };
    this.webService.commonPostMethod('Gate_pass/ajax_gate_pass_history_detail', req).subscribe(
      data => {
        if (data && data.status) {
          try {
            // API returns snapshot in meta_value (your response shape)
            let v: any = data.meta_value ? data.meta_value : (data.response && data.response.meta_value ? data.response.meta_value : {});
            v = v ? v : {};

            if (v.items) {
              let sl_no: number = 1;
              for (let j of v.items) {
                j.sl_no = sl_no;
                j.product_description = j.description ? j.description : (j.product_description ? j.product_description : '');
                sl_no++;
              }
            }
            v.gate_pass_items = v.items ? v.items : [];

            // Minimal mapping for approvals in history detail (for generic-approvals component)
            v.approvals = v.approvals ? v.approvals : [];
            for (let a of v.approvals) {
              a.employee_level = a.employee_level ? a.employee_level : (a.approval_level ? a.approval_level : '');
              a.date_updated = a.date_updated ? a.date_updated : (a.approved_date ? a.approved_date : '');
              this.mapGatePassApproverName(a);
            }

            const attachmentLists = [
              v.attachments,
              v.invoice_attachments,
              v.scan_attachments
            ];
            let allAttachments: any[] = [];
            for (const list of attachmentLists) {
              if (list && list.length) {
                allAttachments = allAttachments.concat(list);
              }
            }
            v.attachment = this.webService.makeAttachment(allAttachments) ? this.webService.makeAttachment(allAttachments) : [];

            // Questionnaire attachments
            v.questionnaire_attachments = v.questionnaire_attachments ? v.questionnaire_attachments : [];
            v.multi_attachments = v.questionnaire_attachments;
            for (let i of v.multi_attachments) {
              const list = i.all_attachment ? i.all_attachment : (i.attachments ? i.attachments : []);
              i.attachments = this.webService.makeAttachment(list) ? this.webService.makeAttachment(list) : [];
              i.unique_id = i.unique_id ? i.unique_id : '';
              i.note_name = i.note_name ? i.note_name : '';
              i.remarks = i.remarks ? i.remarks : '';
            }

            this.gatePassHistoryObj = v;
            this.gatePassHistoryTableDetails.data = this.gatePassHistoryObj;
            this.gatePassHistoryApprovalDetails.data = this.gatePassHistoryObj;
            this.gatePassHistoryDivDetails.data = this.gatePassHistoryObj;

            // Make sure generic components get setup (same as makeFinalData)
            this.gatePassHistoryDivDetails.is_setup = true;
            this.gatePassHistoryDivDetails.setup = this.comanySetup.getData();
            this.gatePassHistoryTableDetails.is_setup = true;
            this.gatePassHistoryTableDetails.setup = this.comanySetup.getData();
            this.gatePassHistoryApprovalDetails.is_setup = true;
            this.gatePassHistoryApprovalDetails.setup = this.comanySetup.getData();

            this.gatePassHistoryApprovalDetails.is_view = true;
            this.gatePassHistoryDivDetails.is_view = true;
            this.gatePassHistoryTableDetails.is_view = true;
          } catch (e) {
            // If any mapping fails, stop loader so UI doesn't hang
            this.toasterService.pop('error', 'Error', 'History data mapping failed');
          }
          this.gatePassHistoryProgressing = false;
          this.commonVariableList.isProgressing = false;
        } else {
          this.toasterService.pop('error', 'Error', data.message);
          this.gatePassHistoryProgressing = false;
          this.commonVariableList.isProgressing = false;
        }
      },
      () => {
        this.toasterService.pop('error', 'Error', 'Something Went Wrong');
        this.gatePassHistoryProgressing = false;
        this.commonVariableList.isProgressing = false;
      }
    );
  }
  showInvoicePayment(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

    let payload: any = { "invoice_payment_id": data.cs_id, "id_type": data.id_type ? data.id_type : 'id', "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('Invoice_payment/ajax_get_invoice_payment_details_byid', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            if (data.response.length > 0) {
              if (data.response[0].payment_details) {
                for (let d of data.response[0].payment_details) {
                  d.vendor = d.vendor_first_name + " " + d.vendor_last_name + "(" + d.vendor_code + ")";
                }
              }
              response = data.response[0] ? data.response[0] : {};
              response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
              response.approvals = response.payment_approvals ? response.payment_approvals : [];

              response.attachment = [];
              response.final_approval_status = response.final_approval_status ? response.final_approval_status : '0';

              // response.attachment = this.webService.makeAttachment(response.attachments)
            }
            else {
              response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

            }
          }
          else {
            this.toasterService.pop('error', 'Error', data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "invoicepaymentreport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showAdhocPayment(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

    let payload: any = { "dp_id": data.id }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('po/getAdhocAdvancePaymentById', payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            // if (data.response.length > 0) {
              response = data.response ? data.response : {};
              response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
              response.approvals = response.adhoc_advance_payment_approvals ? response.adhoc_advance_payment_approvals : [];
             if(response.approvals)
             {
               for(let i of response.approvals)
               {
                 i.employee_code=i.employee_code?i.employee_code:i.approval_employee_code;
               }
             }
              response.attachment = [];
              response.attachment = this.webService.makeAttachment(response.adhoc_advance_payment_attachments)
            // }
            // else {
            //   response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };

            // }
          }
          else {
            this.toasterService.pop('error', 'Error', data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "adhocpaymentreport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop('error', 'Error', 'Something Went Wrong');
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showAndroidInvoice(d)
  {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';

      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoice_drafts/ajax_get_invoice_for_android_by_id';

    let payload: any = {
      "invoice_id": d.id, 'is_this_invoice_no': is_this_invoice_no
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;



            response = data.response[0] ? data.response[0] : {};
            if(response.approvals)
            {
              for(let i of response.approvals)
              {
                i.employee_code=i.approval_code?i.approval_code:'';
              }
            }

            response.vendor_name=response.vendor_first_name+" "+response.vendor_last_name+ "("+response.vendor_code+")";
            response.ship_name=response.ship_to_location_name+" "+"("+response.ship_to_location_code_9_digit+")";
            response.invoice_date = this.webService.formatDate(response.invoice_date, "yy-mm-dd", "-", false) ? response.invoice_date : "";
            response.requested_by=response.added_by_first_name+" "+response.added_by_last_name+" "+"("+response.added_by_employee_code+")";
            response.invoice_no = response.invoice_no ? response.invoice_no : '';
            response.invoice_amount = response.invoice_amount ? response.invoice_amount : '';

            // response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            console.log(response.vendor_gst_no)
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.invoice_approvals = response.approvals ? response.approvals : [];
            // response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachment)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "invoice_android_report";
          response.data = response;
          // console.log(response);
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/generate-invoice-android');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  showInvoice(d) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    d.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
    d.hideApproval=d.hideApproval?d.hideApproval:'0';
    if (d.is_this_invoice_no == '' || d.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Invoices/ajax_get_invoice_details_byid_v2';
    }
    else if (d.is_this_invoice_no == '1') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoices/ajax_get_invoice_details_byvendorinvoicenumber';
    }
    else if (d.is_this_invoice_no == '2') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'Invoices/ajax_get_invoice_details_byvendorinvoicenumber';
    }

    if(d.is_vendor_invoice=='1')
    {
      is_this_invoice_no = '0'
      url = 'Invoices/vendor_invoice_details_byid';
    }
    d.show_multi_inv = d.show_multi_inv ? d.show_multi_inv : '0';
    let payload: any = {
      "invoice_id": d.id, "p_type": d.p_type, 'is_this_invoice_no': is_this_invoice_no
      , "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      is_draft:d.is_draft?d.is_draft:'0',
      "show_multi_inv": d.show_multi_inv,
    }
    // console.log('hey');
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.sub_category_name;
                j.account_name = j.account_name ? j.account_name : '';
                j.account_code = j.account_code ? j.account_code : '';
                j.account_name = j.account_name + "(" + j.account_code + ")";
                j.location = data.response.ship_location_nickname_9_digit + "(" + data.response.ship_location_code_9_digit + ")"
                j.ship_to_location_gst_no=j.ship_to_location_gst_no?j.ship_to_location_gst_no:''
                if(j.ship_to_location_gst_no!=null&&j.ship_to_location_gst_no!='')
                {
                  if(this.country_data.country_id=='101')
                  {
                    if(this.company_setup.display_gstin_with_cost_center_and_vendor=='1')
                    {
                      j.location=j.location+"("+this.company_setup.gstin_display_label+" - "+j.ship_to_location_gst_no+")";
                      j.ship_location=j.ship_location+"("+this.company_setup.gstin_display_label+" - "+j.ship_to_location_gst_no+")";
                    }
                  }
                  else
                  {
                    j.location=j.location
                    j.ship_location=j.ship_location
                  }
                }
                if (data.response.dimension_name != undefined && data.response.dimension_name != '' && data.response.dimension_name != null) {
                  j.location = j.location + "( Dimension -" + data.response.dimension_name + " )"
                }
                j.location=j.ship_location?j.ship_location:j.location;
                // TEMP: remove after UI check
                // Prefer HSN with IGST details when present (same as PO details popup).
                let invHsnCodeIgst: string = (j.hsn_code_igst ? String(j.hsn_code_igst) : '').trim();
                let invHsnCode: string = (j.hsn_code ? String(j.hsn_code) : '').trim();
                j.hsn_code = invHsnCodeIgst ? invHsnCodeIgst : invHsnCode;
                j.product_name = j.product_name + " (" + j.productcode + ")";
                j.product_description = j.product_description ? j.product_description : '';
                j.description = j.description ? j.description : '';
                j.product_description = j.product_description=="" ? j.description : j.product_description;
                j.unplanned_cost = j.unplanned_cost == '1';
              }

            }
            response = data.response ? data.response : {};
            response.advance_amount=response.advance_amount?response.advance_amount:'';
            response.show_multi_inv = d.show_multi_inv;
            
            // Map mailed_irn_no and mailed_eway_bill_no to irn_no and eway_bill_number for UI display
            response.irn_no = response.mailed_irn_no ? response.mailed_irn_no :  '';
            response.eway_bill_number = response.mailed_eway_bill_no ? response.mailed_eway_bill_no :  '';
            
            
            // Extract irn_no and eway_bill_number from scanned_invoice_meta or ocr_suggestions
            try {
              if (response.scanned_invoice_meta) {
                let scannedMeta;
                if (typeof response.scanned_invoice_meta === 'string') {
                  scannedMeta = JSON.parse(response.scanned_invoice_meta);
                } else {
                  scannedMeta = response.scanned_invoice_meta;
                }
                if (scannedMeta && scannedMeta.field_data) {
                  if (scannedMeta.field_data.irn_no && scannedMeta.field_data.irn_no.value) {
                    response.irn_no = scannedMeta.field_data.irn_no.value;
                  }
                  if (scannedMeta.field_data.eway_bill_number && scannedMeta.field_data.eway_bill_number.value) {
                    response.eway_bill_number = scannedMeta.field_data.eway_bill_number.value;
                  }
                }
              }
              // Also check ocr_suggestions as fallback
              if ((!response.irn_no || !response.eway_bill_number) && response.ocr_suggestions) {
                let ocrSuggestions;
                if (typeof response.ocr_suggestions === 'string') {
                  ocrSuggestions = JSON.parse(response.ocr_suggestions);
                } else {
                  ocrSuggestions = response.ocr_suggestions;
                }
                if (ocrSuggestions) {
                  if (!response.irn_no && ocrSuggestions.irn_no) {
                    response.irn_no = typeof ocrSuggestions.irn_no === 'object' && ocrSuggestions.irn_no.value 
                      ? ocrSuggestions.irn_no.value 
                      : ocrSuggestions.irn_no;
                  }
                  if (!response.eway_bill_number && ocrSuggestions.eway_bill_number) {
                    response.eway_bill_number = typeof ocrSuggestions.eway_bill_number === 'object' && ocrSuggestions.eway_bill_number.value 
                      ? ocrSuggestions.eway_bill_number.value 
                      : ocrSuggestions.eway_bill_number;
                  }
                }
              }
              // Ensure values are set (even if empty string)
              if (response.irn_no === undefined || response.irn_no === null) {
                response.irn_no = '';
              }
              if (response.eway_bill_number === undefined || response.eway_bill_number === null) {
                response.eway_bill_number = '';
              }
            } catch (e) {
              console.error('Error parsing scanned_invoice_meta or ocr_suggestions:', e);
              // If parsing fails, ensure values are set
              if (response.irn_no === undefined || response.irn_no === null) {
                response.irn_no = '';
              }
              if (response.eway_bill_number === undefined || response.eway_bill_number === null) {
                response.eway_bill_number = '';
              }
            }
            
            response.common_ship_location=response.ship_location_nickname_9_digit
            if(response.ship_location_code_9_digit!=''&&response.ship_location_code_9_digit!=undefined&&response.ship_location_code_9_digit!=null)
            {
              response.common_ship_location=response.common_ship_location + " (" + response.ship_location_code_9_digit + ")";

            }

            response.ship_to_location_gst_no=response.ship_to_location_gst_no?response.ship_to_location_gst_no:''

            if(response.ship_to_location_gst_no!='')
            {
              if(this.country_data.country_id=='101')
              {
                if(this.company_setup.display_gstin_with_cost_center_and_vendor=='1')
                {
                  response.common_ship_location=response.common_ship_location+"("+this.company_setup.gstin_display_label+" - "+response.ship_to_location_gst_no+")"
                }
              }
              else
              {
                response.common_ship_location=response.common_ship_location
              }
            }
            if(response.is_multi_grn_invoice=='0')
            {
              response.common_ship_location='';
            }
            if(response.invoice_items[0].po_no == '' || response.invoice_items[0].po_no == null || response.invoice_items[0].po_no == undefined){
              response.po_no = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.po_no : ''
            }else{
              response.invoice_items[0].po_no = response.invoice_items[0].po_no? response.invoice_items[0].po_no : response.po_no
              response.po_no=response.is_multi_grn_invoice=='0'?response.invoice_items[0].po_no:response.po_no
            }
            if(response.invoice_items[0].po_date == '' || response.invoice_items[0].po_date == null || response.invoice_items[0].po_date == undefined){
              response.po_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.po_date : ''
            }else{
              response.po_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].po_date:''
            }
            if(response.invoice_items[0].irn_cs_id == '' || response.invoice_items[0].irn_cs_id == null || response.invoice_items[0].irn_cs_id == undefined){
              response.irn_cs_id = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.irn_cs_id : ''
            }else{
              response.irn_cs_id=response.is_multi_grn_invoice=='0'?response.invoice_items[0].irn_cs_id:''
            }
            if(response.invoice_items[0].irn_date == '' || response.invoice_items[0].irn_date == null || response.invoice_items[0].irn_date == undefined){
              response.irn_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.irn_date : ''
            }else{
              response.irn_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].irn_date:''
            }
            if(response.invoice_items[0].grn_cs_id == '' || response.invoice_items[0].grn_cs_id == null || response.invoice_items[0].grn_cs_id == undefined){
              response.grn_cs_id = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.grn_cs_id : ''
            }else{
              response.grn_cs_id=response.is_multi_grn_invoice=='0'?response.invoice_items[0].grn_cs_id:''
            }
            if(response.invoice_items[0].grn_date == '' || response.invoice_items[0].grn_date == null || response.invoice_items[0].grn_date == undefined){
              response.grn_date = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.grn_date : ''
            }else{
              response.grn_date=response.is_multi_grn_invoice=='0'?response.invoice_items[0].grn_date:''
            }
            if(response.invoice_items[0].vendor_address == '' || response.invoice_items[0].vendor_address == null || response.invoice_items[0].vendor_address == undefined){
              response.vendor_address = (response.is_multi_grn_invoice=='0' || response.is_multi_grn_invoice==false) ? response.vendor_address : ''
            }else{
              response.vendor_address=response.is_multi_grn_invoice=='0'?response.invoice_items[0].vendor_address:response.invoice_items[0].vendor_address
            }

           
            response.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
            response.hideApproval=d.hideApproval?d.hideApproval:'0';
            if( response.is_vendor_invoice=='1')
            {
              // response.cs_id= response.invoice_cs_id? response.invoice_cs_id:''
            }
            if( response.is_vendor_invoice!='1')
            {

              response.bill_location_nickname_9_digit=response.invoice_items[0].bill_location_nickname_9_digit
              response.bill_location_code_9_digit=response.invoice_items[0].bill_location_code_9_digit;
            }
            else
            {

              response.bill_location_nickname_9_digit=response.bill_location_nickname_9_digit
              response.bill_location_code_9_digit=response.bill_location_code_9_digit;
            }
   response.ship_location_nickname_9_digit=response.invoice_items[0].ship_location_nickname_9_digit
   response.ship_location_code_9_digit=response.invoice_items[0].ship_location_code_9_digit;


            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            // console.log(response.vendor_gst_no)
            // console.log(response)
            response.requested_by = response.added_by_first_name + " " + response.added_by_last_name + " (" + response.employee_code + ")"
            response.invoice_approvals = response.grn_approvals ? response.grn_approvals : [];
            response.attachment = [];
            response.supporting_document_attachments = [];
            response.credit_note_attachments = [];
            response.attachment = this.webService.makeAttachment(response.attachments)
            response.credit_note_attachments = this.webService.makeAttachment(response.credit_note_attachment)
            response.supporting_document_attachments = this.webService.makeAttachment(response.supporting_document_attachment)
            response.extra_attachment_1 =response.supporting_document_attachments?response.supporting_document_attachments:[],
            response.extra_attachment_2 =response.credit_note_attachments?response.credit_note_attachments:[],
            response.extra_attachment_1_title =this.company_setup.custom_name_for_supporting_document?this.company_setup.custom_name_for_supporting_document:'Supporting Document';
            response.extra_attachment_2_title ='Credit Note Attachment';
            response.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
            response.attachment_title = this.company_setup.custom_name_for_attachment?this.company_setup.custom_name_for_attachment:'Attachments';
            console.log(response.supporting_document_attachments);
            response.is_payment_made_disable = response.is_payment_made_disable? response.is_payment_made_disable : '0' ;
            response.approvals = response.approvals ? response.approvals : [];
            response.rejected_status = response.rejected_status ? response.rejected_status : '0';
            response.is_debit_value = response.is_debit_value ? response.is_debit_value : '0';
            // Invoice hyperlink/view: show lists only when invoice_checklist is present.
            const checklist = response.invoice_checklist;
            const hasInvoiceChecklist = Array.isArray(checklist) && checklist.length > 0;
            response.grn_acceptedList = (hasInvoiceChecklist && response.grn_acceptedList) ? response.grn_acceptedList : [];
            response.grn_rejectedList = (hasInvoiceChecklist && response.grn_rejectedList) ? response.grn_rejectedList : [];
            if( response.is_vendor_invoice=='1' && response.rejected_status=='1')
            {
              response.approvals = [];
              response.approvals.push({
                "approval_first_name" : response.approval_first_name ? response.approval_first_name : '',
                "approval_last_name" : response.approval_last_name ? response.approval_last_name : '',
                "employee_code" : response.approval_employee_code ? response.approval_employee_code : '',
                "approval_status" : '2',
                "date_updated" : response.rejected_date ? response.rejected_date : '',
                "reason" : response.rejected_reason ? response.rejected_reason : '',
                "date_added" : response.requested_date ? response.requested_date : '',
              });
            }
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
          }
          response.id = "invoicereport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/add-invoice-v2');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showRecurringInvoice(d) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [],"extra_attachment_2":[] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    d.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
    if (d.is_this_invoice_no == '' || d.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    else if (d.is_this_invoice_no == '1') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    else if (d.is_this_invoice_no == '2') {
      is_this_invoice_no = d.is_this_invoice_no ? d.is_this_invoice_no : '1';
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }

    if(d.is_vendor_invoice=='1')
    {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/invoiceDetails';
    }
    if(d.is_draft=='1')
    {
      is_this_invoice_no = '0'
      url = 'invoice/Recurring_invoice/draftedInvoiceDetails';
    }
    let payload: any = {
      "drafted_invoice_id": d.drafted_invoice_id?d.drafted_invoice_id:'',
      "invoice_id": d.id, "p_type": d.p_type, 'is_this_invoice_no': is_this_invoice_no
      , "merge_grn_irn": this.company_setup.merge_grn_irn ? this.company_setup.merge_grn_irn : '0',
      is_draft:d.is_draft?d.is_draft:'0',
      is_modified:d.is_modified?d.is_modified:'0'
    }
    if(d.is_draft!='1')
    {
      delete payload['drafted_invoice_id']
    }
    else
    {
     // delete payload['invoice_id']

    }
    // console.log('hey');
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.product_sub_category_name;
                j.product_name = j.product_name
                j.account_name=j.account_name?j.account_name:j.account_code;
              }

            }
            if(data.response.invoice_approvals)
            {
              for(let i of data.response.invoice_approvals)
              {
                i.approval_first_name=i.approval_first_name?i.approval_first_name:i.approval_by
                i.approval_last_name=i.approval_last_name?i.approval_last_name:""
                i.employee_code=i.employee_code?i.employee_code:""

              }
            }
            response = {...data.response};
            response.vendor_address=response.vendor + response.vendor_address
            response.is_vendor_invoice=d.is_vendor_invoice?d.is_vendor_invoice:'0';
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.requested_by = response.requested_by
            response.invoice_approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.attachment = [];
            response.supporting_document_attachments =response.supporting_document_attachments?response.supporting_document_attachments: [];
            response.attachment = this.webService.makeAttachment(response.attachments)
            response.supporting_document_attachments = this.webService.makeAttachment(response.supporting_document_attachments)
            response.extra_attachment_1 =response.supporting_document_attachments?response.supporting_document_attachments:[]
            response.extra_attachment_1_title =this.company_setup.RIT_custom_name_for_supporting_document?this.company_setup.RIT_custom_name_for_supporting_document:'Supporting Document';
            response.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
            response.attachment_title = this.company_setup.RIT_custom_name_for_attachment?this.company_setup.RIT_custom_name_for_attachment:'Attachments';
            console.log(response.supporting_document_attachments);
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "recurring_invoicereport";
          response.data = response;
          this.modalDetails.name=this.webService.getMainMenuNameByGivenUrl('/create-recurring-inv');

          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showSalesInvoice(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Sales_invoices/getInvoiceById';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Sales_invoices/getInvoiceById';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Sales_invoices/getInvoiceById';
    }
    let payload: any = {
      "sales_invoice_id": data.id, 'is_this_invoice_no': is_this_invoice_no
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;

            if (data.response.invoice_items) {
              for (let j of data.response.invoice_items) {
                j.unit_type_name = j.unit_type_name ? j.unit_type_name : j.unit_type
                j.subcategory_name = j.subcategory_name ? j.subcategory_name : j.sub_category_name;
                j.account_name = j.account_name ? j.account_name : '';
                j.account_code = j.account_code ? j.account_code : '';
                j.account_name = j.account_name + "(" + j.account_code + ")";
                j.location = data.response.ship_to_location
                if (data.response.dimension_name != undefined && data.response.dimension_name != '' && data.response.dimension_name != null) {
                  j.location = j.location + "( Dimension -" + data.response.dimension_name + " )"
                }
                j.product_name = j.product_name + " (" + j.productcode + ")";
              }

            }

            response = data.response ? data.response : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.employee_code ? response.employee_code : '';

            response.approvals = response.invoice_approvals ? response.invoice_approvals : [];
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.invoice_attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "salesinvoicereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }

  showDCNote(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'journal_entry/ajax_get_single_db_cr_note';
    }
    let payload: any = {
      "note_id": data.id?data.id:'', 'is_this_invoice_no': is_this_invoice_no,
       "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;



            response = Array.isArray(data.response) ? (data.response.length>0?data.response[0]:{}) : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : '';
            response.final_approval_status = response.final_approval_status ? response.final_approval_status : '0';
            if(response.approavls)
            {
              for(let i of response.approvals)
              {
                i.approval_first_name=i.first_name;
                i.approval_last_name=i.last_name;
                i.employee_code=i.employee_code?i.employee_code:'';
              }
            }
            response.approvals = response.approvals ? response.approvals : [];
            response.je_date=this.webService.formatDate(response.je_date,'dd-mm-yy','-')?this.webService.formatDate(response.je_date,'dd-mm-yy','-'):'';
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "dcnotereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showVendorCreditNote(data) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let url: any = '';
    if (data.is_this_invoice_no == '' || data.is_this_invoice_no == undefined) {
      is_this_invoice_no = '0'
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    else if (data.is_this_invoice_no == '1') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    else if (data.is_this_invoice_no == '2') {
      is_this_invoice_no = data.is_this_invoice_no ? data.is_this_invoice_no : '1';
      url = 'Vendor_management/ajax_db_cr_note_by_id';
    }
    let payload: any = {
      "dc_note_id": data.id ? data.id : '', 'is_this_invoice_no': is_this_invoice_no,
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod(url, payload).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = Array.isArray(data.response) ? (data.response.length > 0 ? data.response[0] : {}) : {};
            response.vendor_gst_no = response.vendor_gst_number ? response.vendor_gst_number : '';
            response.added_by_first_name = response.added_by_first_name ? response.added_by_first_name : '';
            response.added_by_last_name = response.added_by_last_name ? response.added_by_last_name : '';
            response.employee_code = response.added_by_employee_code ? response.added_by_employee_code : '';
            response.approvals = response.approvals ? response.approvals : [];
            response.je_date = this.webService.formatDate(response.je_date, 'dd-mm-yy', '-') ? this.webService.formatDate(response.je_date, 'dd-mm-yy', '-') : '';
            response.attachment = [];

            response.attachment = this.webService.makeAttachment(response.attachments)
          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "creditnotereport";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = { "extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showMyAdvance(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "id": data.id ? data.id : '' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('project/My_advance_master/get_all_advance_by_id', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response[0] ? data.response[0] : {};
            response.attachment = this.webService.makeAttachment(response.advance_attachment) ? this.webService.makeAttachment(response.advance_attachment) : []
            response.project_details = response.project_name + "(" + response.project_code + ")";
            response.added_by = response.first_name + " " + response.last_name + "(" + response.employee_code + ")";
            response.added_for = response.advance_employee_first_name + " " + response.advance_employee_last_name + "(" + response.advance_employee_code + ")";
            response.is_reimburshable = response.is_reimburshable == '1' ? 'YES' : 'NO';
            response.items = [];
            response.advance_type = response.advance_type_name + "(" + response.advance_type_code + ")";
            response.items.push(
              {
                'sl_no': '1', 'advance_type': response.advance_type, 'from_date': response.from_date, 'to_date': response.to_date,
                'advance_amount': response.advance_amount, 'is_reimburshable': response.is_reimburshable,
                'attachment': response.attachment ? response.attachment : [], 'remarks': response.remarks
              }
            )
            if (response.advance_approvals) {
              for (let i of response.advance_approvals) {
                i.approval_first_name = i.approval_by_first_name
                i.approval_last_name = i.approval_by_last_name
                i.employee_code = i.approval_employee_code;
                i.reason = i.reason ? i.reason : '';

              }
            }



            response.approvals = []
            response.approvals = response.advance_approvals ? response.advance_approvals : [];

          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "my_advance_report";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  showEmployeeAdvancePayment(data) {

    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let payload: any = { "id": data.id ? data.id : '' }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('project/My_advance_master/get_all_advance_payment_by_id', data).
      subscribe(
        data => {
          if (data.status) {
            let index: number = 0;
            response = data.response[0] ? data.response[0] : {};
            // response.attachment = this.webService.makeAttachment(response.advance_attachment) ? this.webService.makeAttachment(response.advance_attachment) : []
            response.bank_details = response.bank_name + "(" + response.account_no + ")";
            response.added_by = response.added_by_first_name + " " + response.added_by_last_name + "(" + response.added_by_employee_code + ")";
            // response.added_for=response.advance_employee_first_name+" "+response.advance_employee_last_name+"("+response.advance_employee_code+")";
            // response.is_reimburshable=response.is_reimburshable=='1'?'YES':'NO';
            response.items = [];
            // response.advance_type=response.advance_type_name+"("+response.advance_type_code+")";
            response.items.push(
              {
                'sl_no': '1', 'advance_amount': response.advance_amount, 'payble_amount': response.payble_amount,
                'retention_amount': response.retention_amount, 'date_of_payment': response.date_of_payment,
                'bank_details': response.bank_details, 'remarks': response.remarks
              }
            )
            if (response.approvals) {
              for (let i of response.approvals) {
                i.approval_first_name = i.approval_first_name
                i.approval_last_name = i.approval_last_name
                i.employee_code = i.approval_by_employee_code;
                i.reason = i.reason ? i.reason : '';

              }
            }




          }
          else {
            this.toasterService.pop('error', "Error", data.message);
            response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          }
          response.id = "employee_advance_payment_report";
          response.data = response;
          this.makeFinalData(response);
        },
        error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong")
          response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
          this.commonVariableList.isProgressing = false;
        }
      );
  }
  makeFinalData(response) {
    let c = 1;
    for(let i of response.approvals) {
      i.employee_level = i.employee_level ? i.employee_level : c;
      c++;
    }

    this.commonVariableList.dataList.push(response)
    this.commonVariableList.beforedivList = response.beforedivList ? response.beforedivList : []
    this.commonVariableList.afterdivList = response.afterdivList ? response.afterdivList : []
    this.commonVariableList.modalDetails.is_view = true;
    this.commonVariableList.isProgressing = false;

    this.commonVariableList.afterDivDetails = {};
    this.commonVariableList.afterDivDetails = response;
    this.commonVariableList.beforeDivDetails = {};
    this.commonVariableList.beforeDivDetails = response;
    this.commonVariableList.tableDetails = {};
    this.commonVariableList.tableDetails = response;
    this.commonVariableList.approvalDetails = {};
    this.commonVariableList.approvalDetails = response;
    this.commonVariableList.attachments = [];
    this.commonVariableList.attachments = response.attachment ? response.attachment : [];
    this.commonVariableList.extra_attachment_1_title=response.extra_attachment_1_title?response.extra_attachment_1_title:'';
    this.commonVariableList.extra_attachment_2_title=response.extra_attachment_2_title?response.extra_attachment_2_title:'';
    this.commonVariableList.contractualPoAttachmentsTitle='Attach Signed Contract Copy'
    this.commonVariableList.attachment_title_qc=response.attachment_title_qc?response.attachment_title_qc:'';
    this.commonVariableList.contractualPoAttachmentsTitle='Contract PO Attachment'
    this.commonVariableList.attachment_title=response.attachment_title?response.attachment_title:'';

    this.commonVariableList.po_additional_attachments = response.po_additional_attachment ? response.po_additional_attachment : [];
    this.commonVariableList.po_additional_attachments_title = response.po_additional_attachment ?  response.po_additional_attachments_title:''
    
    this.commonVariableList.pr_attachments = []

    this.commonVariableList.pr_attachments = this.webService.makeAttachment( response.pr_attachments) ? this.webService.makeAttachment( response.pr_attachments) : []
    this.commonVariableList.afterDivDetails.is_setup=true;
    this.commonVariableList.afterDivDetails.setup=this.comanySetup.getData();

    this.commonVariableList.beforeDivDetails.is_setup=true;
    this.commonVariableList.beforeDivDetails.setup=this.comanySetup.getData();


    this.commonVariableList.tableDetails.is_setup=true;
    this.commonVariableList.tableDetails.setup=this.comanySetup.getData();

    this.commonVariableList.approvalDetails.is_setup=true;
    this.commonVariableList.approvalDetails.setup=this.comanySetup.getData();

    // Setup allocableCostDetails
    this.setupAllocableCostDetails();


    this.commonVariableList.extra_attachment_1 = response.extra_attachment_1 ? response.extra_attachment_1 : [];
    this.commonVariableList.extra_attachment_2 = response.extra_attachment_2 ? response.extra_attachment_2 : [];
    this.commonVariableList.extra_attachment_qc = response.extra_attachment_qc ? response.extra_attachment_qc : [];
    this.commonVariableList.contractualPoAttachments = response.contractualPoAttachments ? response.contractualPoAttachments : [];
    this.commonVariableList.fulfilled_po_upload_invoice = response.fulfilled_po_upload_invoice ? response.fulfilled_po_upload_invoice : [];
    this.commonVariableList.fulfilled_po_upload_invoice_title = response.fulfilled_po_upload_invoice_title ? response.fulfilled_po_upload_invoice_title : '';
    this.commonVariableList.fulfilled_po_vendor_attachment = response.fulfilled_po_vendor_attachment ? response.fulfilled_po_vendor_attachment : [];
    this.commonVariableList.fulfilled_po_vendor_attachment_title = response.fulfilled_po_vendor_attachment_title ? response.fulfilled_po_vendor_attachment_title : '';
  }
  initListener() {
    document.body.addEventListener('keypress', (event) => this.reset(event));
    document.body.addEventListener('keydown', (event) => this.reset(event));
    document.body.addEventListener('keyup', (event) => this.reset(event));

  }
  reset(event) {
    if (event.keyCode == '27') {
      this.modalDetails.is_view = false;
      document.body.style.overflow = 'auto';
    }
  }
  getDraftInvoiceData(temp) {
    let requestObj = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      "drafted_invoice_id": temp.drafted_invoice_id ? temp.drafted_invoice_id : '',
      "invoice_id": temp.id ? temp.id : '',
      is_draft: '1',
      is_this_invoice_no: '0'
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod("invoice/Recurring_invoice/draftedInvoiceDetails", requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.raiseInvoice(data.response,temp)
          }
          this.commonVariableList.isProgressing = false;
        },
        error => {
          this.commonVariableList.isProgressing = false;
        }
        )
      }
  raiseInvoice(data:any,temp)
  {
    this.hideModal()
    let a:any={'action_type':'recurring_copy','drafted_invoice_id':temp.drafted_invoice_id?temp.drafted_invoice_id:'','draft_invoice_id':temp.drafted_invoice_id?temp.drafted_invoice_id:'','invoice_id':temp.id?temp.id:'','is_draft':'1','invoice_no':data.vendor_invoice_no?data.vendor_invoice_no:'',
    'vendor_id':data.vendor_id?data.vendor_id:'','vendor_location_id':data.vendor_location_id?data.vendor_location_id:''}
localStorage.setItem('direct-invoice',this.eesdesService.set(JSON.stringify((a))));
this.webService.redirectURL('/raise-recurring-direct-invoice');
  }

  showRfqData(data, type) {
    this.commonVariableList.dataList = [];
    let response: any = { "extra_attachment_1": [],"items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
    let is_this_invoice_no: any = '';
    let payload: any = {
      "rfq_id": data.rfq_id?data.rfq_id:'',
       "company_id": this._localStorageService.getEmpCompanyId() == undefined ? '0' : this._localStorageService.getEmpCompanyId(),
       "is_report": "1"
    }
    this.commonVariableList.isProgressing = true;
    this.webService.commonPostMethod('/Vendor_management/ajax_view_rfq_id', payload).subscribe(data => {
      if (data.status) {
        let index: number = 0;
        response = Array.isArray(data.response) ? (data.response.length>0?data.response[0]:{}) : {};
        if(response.rfq_approvals){
          for(let i of response.rfq_approvals){
            i.approval_first_name=i.approval_first_name;
            i.approval_last_name=i.approval_last_name;
            i.employee_code=i.employee_code?i.employee_code:'';
          }
        }
        response.attachment_title = this.getColumnNameQuotationManagement('rfq_documents','Uploaded RFQ Documents');
        response.attachments = response.rfq_attachments ? response.rfq_attachments : [];
        response.rfq_approvals = response.rfq_approvals ? response.rfq_approvals : [];
        response.attachment = this.webService.makeAttachment(response.attachments)
        let cost_center_budget_details_obj = {
          "annual_budget_amount": '',
          "budget_consumed_till_date": '',
          "current_amount_rfq": '',
          "balance_budget": '',
        }
        response.cost_center_budget_details_obj = response.cost_center_budget_details_obj ? response.cost_center_budget_details_obj : cost_center_budget_details_obj;
        this.fillPaymentScreenRfqBudgetDetails(response);
        this.fillPaymentScreenRfqActivityAndDocs(response);
      }
      else {
        this.toasterService.pop('error', "Error", data.message);
        response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
      }
      response.id = type;
      response.data = response;
      this.makeFinalData(response);
    },error => {
      this.toasterService.pop("Error", "Something Went Wrong")
      response = {"extra_attachment_1": [], "items": [], "approvals": [], "attachment": [], "beforedivList": [], "afterdivList": [] };
      this.commonVariableList.isProgressing = false;
    });
  }

  isEmptyRfqBudgetValue(value) {
    return value === '' || value === null || value === undefined;
  }

  isPaymentRfqPopup() {
    return !!(this.modalDetails && (this.modalDetails.from_add_advance_payment || this.modalDetails.from_add_invoice_payment || this.modalDetails.from_add_invoice));
  }

  fillPaymentScreenRfqBudgetDetails(response) {
    if (!this.isPaymentRfqPopup()) {
      return;
    }
    if (!response || !response.cost_center_budget_details_obj) {
      return;
    }
    let budgetObj = response.cost_center_budget_details_obj;
    if (this.isEmptyRfqBudgetValue(budgetObj.current_amount_rfq)) {
      let topLevelCurrentAmount = parseFloat(this.webService.convertNaN(response.current_amount_rfq));
      if (topLevelCurrentAmount > 0) {
        budgetObj.current_amount_rfq = response.current_amount_rfq;
      } else {
        let selectedVendorPrice = 0;
        let vendorItems = response.vendor_items ? response.vendor_items : [];
        vendorItems.forEach((item) => {
          selectedVendorPrice = selectedVendorPrice + parseFloat(this.webService.convertNaN(item.selected_vendor_price));
        });
        selectedVendorPrice = this.webService.convertNaN(parseFloat(this.webService.convertNaN(selectedVendorPrice)));
        budgetObj.current_amount_rfq = selectedVendorPrice;
      }
    }
    if (this.isEmptyRfqBudgetValue(budgetObj.balance_budget)) {
      let totalConsumeCurrent = parseFloat(this.webService.convertNaN(budgetObj.budget_consumed_till_date)) + parseFloat(this.webService.convertNaN(budgetObj.current_amount_rfq));
      budgetObj.balance_budget = parseFloat(this.webService.convertNaN(budgetObj.annual_budget_amount)) - parseFloat(this.webService.convertNaN(totalConsumeCurrent));
      budgetObj.balance_budget = this.webService.convertNaN(parseFloat(this.webService.convertNaN(budgetObj.balance_budget)));
    }
  }

  fillPaymentScreenRfqActivityAndDocs(response) {
    if (!this.isPaymentRfqPopup() || !response) {
      return;
    }
    response.from_payment_rfq_popup = true;
    response.form_fields = Array.isArray(response.form_fields) ? response.form_fields : [];
    response.commercial_form_fields = Array.isArray(response.commercial_form_fields) ? response.commercial_form_fields : [];
    response.rfq_vendor_details = Array.isArray(response.rfq_vendor_details) ? response.rfq_vendor_details : [];
    response.supporting_attachments = Array.isArray(response.supporting_attachments) ? response.supporting_attachments : [];
    for (let vendor of response.rfq_vendor_details) {
      vendor.is_responded = Array.isArray(vendor.is_responded) ? vendor.is_responded : [];
      vendor.commercial_is_responded = Array.isArray(vendor.commercial_is_responded) ? vendor.commercial_is_responded : [];
      for (let n of vendor.is_responded) {
        n.supported_files = Array.isArray(n.supported_files) ? n.supported_files : [];
      }
      for (let n of vendor.commercial_is_responded) {
        n.supported_files = Array.isArray(n.supported_files) ? n.supported_files : [];
      }
    }
    if (response.supporting_attachments.length > 0) {
      response.extra_attachment_1_title = this.getColumnNameQuotationManagement('technical_supporting_docs', 'Technical Supporting Docs');
      response.extra_attachment_1 = this.webService.makeAttachment(response.supporting_attachments);
    }
  }

  getColumnNameQuotationManagement(key, default_data) {
    if (key == '' || key == undefined) {
      return default_data ? default_data : '-';
    }
    if (this.company_setup.quotation_management_master_column_list.length == undefined || this.company_setup.quotation_management_master_column_list.length <= 0) {
      return default_data ? default_data : '-';

    }
    let temp: any = [];
    temp = this.company_setup.quotation_management_master_column_list.filter((v) => { return v.key == key });
    if (temp.length == undefined || temp.length <= 0) {
      return default_data ? default_data : '-';
    }
    return temp[0].custom_name ? temp[0].custom_name : '-'
  }
  getApprovedInvoicePdf() {
    const html2canvas: any = _html2canvas;
    const modalContent = document.querySelector('.modal-content') as HTMLElement;
    const originalMaxHeight = modalContent.style.maxHeight;
    if(modalContent){
      this.commonVariableList.isProgressing = true;
    }
    // Temporarily remove max-height
    modalContent.style.maxHeight = 'none';

    html2canvas(modalContent, {
      scale: window.devicePixelRatio,
      useCORS: true,
      allowTaint: true,
      logging: true,
    }).then(canvas => {
      // Restore the original max-height
      modalContent.style.maxHeight = originalMaxHeight;

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 208; // A4 size in mm
      const pageHeight = 295; // A4 size in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      this.commonVariableList.isProgressing = false
      pdf.save('Invoice_Data.pdf');
    }).catch(error => {
      this.commonVariableList.isProgressing = false
      console.error('Error capturing content:', error);
    });
  }
  isVisibled(key)
  {
    return this.company_setup.vendor_invoice_column_list.some((v)=>{return v.id==key && v.isVisible})
  }

  /**
   * Setup allocableCostDetails similar to tableDetails
   */
  setupAllocableCostDetails() {
    this.commonVariableList.allocableCostDetails = {};
    this.commonVariableList.allocableCostDetails.id = this.modalDetails.id || 'poreport';
    this.commonVariableList.allocableCostDetails.lines = this.commonVariableList.allocableCostLines || [];
    this.commonVariableList.allocableCostDetails.viewContext = (this.commonVariableList.tableDetails && this.commonVariableList.tableDetails.data) ? this.commonVariableList.tableDetails.data : {};
    this.commonVariableList.allocableCostDetails.caption = 'Additional Cost Line items (Not Part of Vendor PO)';
    this.commonVariableList.allocableCostDetails.is_setup = true;
    this.commonVariableList.allocableCostDetails.setup = this.comanySetup.getData();
    this.commonVariableList.allocableCostDetails.is_view = this.isAllocableCostTableVisible();
  }

  /**
   * Check if allocable cost table should be visible (main view)
   */
  isAllocableCostTableVisible(): boolean {
    return this.modalDetails.id === 'poreport' 
           && this.commonVariableList.is_allocable_cost 
           && this.company_setup.enable_allocable_cost_direct_po == '1' 
           && this.commonVariableList.allocableCostLines 
           && this.commonVariableList.allocableCostLines.length > 0;
  }

  /**
   * Check if allocable cost table should be visible for history item
   */
  isAllocableCostTableVisibleForHistory(item: any): boolean {
    return this.modalDetails.id === 'poreport' 
           && (item.is_allocable_cost == '1' || item.is_allocable_cost == 1 || item.is_allocable_cost == true)
           && this.company_setup.enable_allocable_cost_direct_po == '1' 
           && item.allocable_cost_items 
           && item.allocable_cost_items.length > 0;
  }

  getTotalCostLineAmount(currencyType: string): number {
    if (!this.commonVariableList.allocableCostLines || this.commonVariableList.allocableCostLines.length === 0) {
      return 0;
    }
    let total = 0;
    for (let costLine of this.commonVariableList.allocableCostLines) {
      if (currencyType === 'po_currency') {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_po_currency)) || 0;
      } else {
        total += parseFloat(this.webService.convertNaN(costLine.planned_amount_in_base_currency)) || 0;
      }
    }
    return total;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src2094230074/src/src/app/generic-ui-components/generic-modal-popup/generic-modal-popup.component.ts